
/* **********************************************
     Begin prism-core.js
********************************************** */

/// <reference lib="WebWorker"/>

var _self = (typeof window !== 'undefined')
	? window   // if in browser
	: (
		(typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope)
			? self // if in worker
			: {}   // if in node js
	);

/**
 * Prism: Lightweight, robust, elegant syntax highlighting
 *
 * @license MIT <https://opensource.org/licenses/MIT>
 * @author Lea Verou <https://lea.verou.me>
 * @namespace
 * @public
 */
var Prism = (function (_self) {

	// Private helper vars
	var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
	var uniqueId = 0;

	// The grammar object for plaintext
	var plainTextGrammar = {};


	var _ = {
		/**
		 * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
		 * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
		 * additional languages or plugins yourself.
		 *
		 * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
		 *
		 * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.manual = true;
		 * // add a new <script> to load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */
		manual: _self.Prism && _self.Prism.manual,
		/**
		 * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
		 * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
		 * own worker, you don't want it to do this.
		 *
		 * By setting this value to `true`, Prism will not add its own listeners to the worker.
		 *
		 * You obviously have to change this value before Prism executes. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.disableWorkerMessageHandler = true;
		 * // Load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */
		disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,

		/**
		 * A namespace for utility methods.
		 *
		 * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
		 * change or disappear at any time.
		 *
		 * @namespace
		 * @memberof Prism
		 */
		util: {
			encode: function encode(tokens) {
				if (tokens instanceof Token) {
					return new Token(tokens.type, encode(tokens.content), tokens.alias);
				} else if (Array.isArray(tokens)) {
					return tokens.map(encode);
				} else {
					return tokens.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\u00a0/g, ' ');
				}
			},

			/**
			 * Returns the name of the type of the given value.
			 *
			 * @param {any} o
			 * @returns {string}
			 * @example
			 * type(null)      === 'Null'
			 * type(undefined) === 'Undefined'
			 * type(123)       === 'Number'
			 * type('foo')     === 'String'
			 * type(true)      === 'Boolean'
			 * type([1, 2])    === 'Array'
			 * type({})        === 'Object'
			 * type(String)    === 'Function'
			 * type(/abc+/)    === 'RegExp'
			 */
			type: function (o) {
				return Object.prototype.toString.call(o).slice(8, -1);
			},

			/**
			 * Returns a unique number for the given object. Later calls will still return the same number.
			 *
			 * @param {Object} obj
			 * @returns {number}
			 */
			objId: function (obj) {
				if (!obj['__id']) {
					Object.defineProperty(obj, '__id', { value: ++uniqueId });
				}
				return obj['__id'];
			},

			/**
			 * Creates a deep clone of the given object.
			 *
			 * The main intended use of this function is to clone language definitions.
			 *
			 * @param {T} o
			 * @param {Record<number, any>} [visited]
			 * @returns {T}
			 * @template T
			 */
			clone: function deepClone(o, visited) {
				visited = visited || {};

				var clone; var id;
				switch (_.util.type(o)) {
					case 'Object':
						id = _.util.objId(o);
						if (visited[id]) {
							return visited[id];
						}
						clone = /** @type {Record<string, any>} */ ({});
						visited[id] = clone;

						for (var key in o) {
							if (o.hasOwnProperty(key)) {
								clone[key] = deepClone(o[key], visited);
							}
						}

						return /** @type {any} */ (clone);

					case 'Array':
						id = _.util.objId(o);
						if (visited[id]) {
							return visited[id];
						}
						clone = [];
						visited[id] = clone;

						(/** @type {Array} */(/** @type {any} */(o))).forEach(function (v, i) {
							clone[i] = deepClone(v, visited);
						});

						return /** @type {any} */ (clone);

					default:
						return o;
				}
			},

			/**
			 * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
			 *
			 * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
			 *
			 * @param {Element} element
			 * @returns {string}
			 */
			getLanguage: function (element) {
				while (element) {
					var m = lang.exec(element.className);
					if (m) {
						return m[1].toLowerCase();
					}
					element = element.parentElement;
				}
				return 'none';
			},

			/**
			 * Sets the Prism `language-xxxx` class of the given element.
			 *
			 * @param {Element} element
			 * @param {string} language
			 * @returns {void}
			 */
			setLanguage: function (element, language) {
				// remove all `language-xxxx` classes
				// (this might leave behind a leading space)
				element.className = element.className.replace(RegExp(lang, 'gi'), '');

				// add the new `language-xxxx` class
				// (using `classList` will automatically clean up spaces for us)
				element.classList.add('language-' + language);
			},

			/**
			 * Returns the script element that is currently executing.
			 *
			 * This does __not__ work for line script element.
			 *
			 * @returns {HTMLScriptElement | null}
			 */
			currentScript: function () {
				if (typeof document === 'undefined') {
					return null;
				}
				if (document.currentScript && document.currentScript.tagName === 'SCRIPT' && 1 < 2 /* hack to trip TS' flow analysis */) {
					return /** @type {any} */ (document.currentScript);
				}

				// IE11 workaround
				// we'll get the src of the current script by parsing IE11's error stack trace
				// this will not work for inline scripts

				try {
					throw new Error();
				} catch (err) {
					// Get file src url from stack. Specifically works with the format of stack traces in IE.
					// A stack will look like this:
					//
					// Error
					//    at _.util.currentScript (http://localhost/components/prism-core.js:119:5)
					//    at Global code (http://localhost/components/prism-core.js:606:1)

					var src = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(err.stack) || [])[1];
					if (src) {
						var scripts = document.getElementsByTagName('script');
						for (var i in scripts) {
							if (scripts[i].src == src) {
								return scripts[i];
							}
						}
					}
					return null;
				}
			},

			/**
			 * Returns whether a given class is active for `element`.
			 *
			 * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
			 * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
			 * given class is just the given class with a `no-` prefix.
			 *
			 * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
			 * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
			 * ancestors have the given class or the negated version of it, then the default activation will be returned.
			 *
			 * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
			 * version of it, the class is considered active.
			 *
			 * @param {Element} element
			 * @param {string} className
			 * @param {boolean} [defaultActivation=false]
			 * @returns {boolean}
			 */
			isActive: function (element, className, defaultActivation) {
				var no = 'no-' + className;

				while (element) {
					var classList = element.classList;
					if (classList.contains(className)) {
						return true;
					}
					if (classList.contains(no)) {
						return false;
					}
					element = element.parentElement;
				}
				return !!defaultActivation;
			}
		},

		/**
		 * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
		 *
		 * @namespace
		 * @memberof Prism
		 * @public
		 */
		languages: {
			/**
			 * The grammar for plain, unformatted text.
			 */
			plain: plainTextGrammar,
			plaintext: plainTextGrammar,
			text: plainTextGrammar,
			txt: plainTextGrammar,

			/**
			 * Creates a deep copy of the language with the given id and appends the given tokens.
			 *
			 * If a token in `redef` also appears in the copied language, then the existing token in the copied language
			 * will be overwritten at its original position.
			 *
			 * ## Best practices
			 *
			 * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
			 * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
			 * understand the language definition because, normally, the order of tokens matters in Prism grammars.
			 *
			 * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
			 * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
			 *
			 * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
			 * @param {Grammar} redef The new tokens to append.
			 * @returns {Grammar} The new language created.
			 * @public
			 * @example
			 * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
			 *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
			 *     // at its original position
			 *     'comment': { ... },
			 *     // CSS doesn't have a 'color' token, so this token will be appended
			 *     'color': /\b(?:red|green|blue)\b/
			 * });
			 */
			extend: function (id, redef) {
				var lang = _.util.clone(_.languages[id]);

				for (var key in redef) {
					lang[key] = redef[key];
				}

				return lang;
			},

			/**
			 * Inserts tokens _before_ another token in a language definition or any other grammar.
			 *
			 * ## Usage
			 *
			 * This helper method makes it easy to modify existing languages. For example, the CSS language definition
			 * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
			 * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
			 * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
			 * this:
			 *
			 * ```js
			 * Prism.languages.markup.style = {
			 *     // token
			 * };
			 * ```
			 *
			 * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
			 * before existing tokens. For the CSS example above, you would use it like this:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'cdata', {
			 *     'style': {
			 *         // token
			 *     }
			 * });
			 * ```
			 *
			 * ## Special cases
			 *
			 * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
			 * will be ignored.
			 *
			 * This behavior can be used to insert tokens after `before`:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'comment', {
			 *     'comment': Prism.languages.markup.comment,
			 *     // tokens after 'comment'
			 * });
			 * ```
			 *
			 * ## Limitations
			 *
			 * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
			 * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
			 * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
			 * deleting properties which is necessary to insert at arbitrary positions.
			 *
			 * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
			 * Instead, it will create a new object and replace all references to the target object with the new one. This
			 * can be done without temporarily deleting properties, so the iteration order is well-defined.
			 *
			 * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
			 * you hold the target object in a variable, then the value of the variable will not change.
			 *
			 * ```js
			 * var oldMarkup = Prism.languages.markup;
			 * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
			 *
			 * assert(oldMarkup !== Prism.languages.markup);
			 * assert(newMarkup === Prism.languages.markup);
			 * ```
			 *
			 * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
			 * object to be modified.
			 * @param {string} before The key to insert before.
			 * @param {Grammar} insert An object containing the key-value pairs to be inserted.
			 * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
			 * object to be modified.
			 *
			 * Defaults to `Prism.languages`.
			 * @returns {Grammar} The new grammar object.
			 * @public
			 */
			insertBefore: function (inside, before, insert, root) {
				root = root || /** @type {any} */ (_.languages);
				var grammar = root[inside];
				/** @type {Grammar} */
				var ret = {};

				for (var token in grammar) {
					if (grammar.hasOwnProperty(token)) {

						if (token == before) {
							for (var newToken in insert) {
								if (insert.hasOwnProperty(newToken)) {
									ret[newToken] = insert[newToken];
								}
							}
						}

						// Do not insert token which also occur in insert. See #1525
						if (!insert.hasOwnProperty(token)) {
							ret[token] = grammar[token];
						}
					}
				}

				var old = root[inside];
				root[inside] = ret;

				// Update references in other language definitions
				_.languages.DFS(_.languages, function (key, value) {
					if (value === old && key != inside) {
						this[key] = ret;
					}
				});

				return ret;
			},

			// Traverse a language definition with Depth First Search
			DFS: function DFS(o, callback, type, visited) {
				visited = visited || {};

				var objId = _.util.objId;

				for (var i in o) {
					if (o.hasOwnProperty(i)) {
						callback.call(o, i, o[i], type || i);

						var property = o[i];
						var propertyType = _.util.type(property);

						if (propertyType === 'Object' && !visited[objId(property)]) {
							visited[objId(property)] = true;
							DFS(property, callback, null, visited);
						} else if (propertyType === 'Array' && !visited[objId(property)]) {
							visited[objId(property)] = true;
							DFS(property, callback, i, visited);
						}
					}
				}
			}
		},

		plugins: {},

		/**
		 * This is the most high-level function in Prism’s API.
		 * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
		 * each one of them.
		 *
		 * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
		 *
		 * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
		 * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
		 * @memberof Prism
		 * @public
		 */
		highlightAll: function (async, callback) {
			_.highlightAllUnder(document, async, callback);
		},

		/**
		 * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
		 * {@link Prism.highlightElement} on each one of them.
		 *
		 * The following hooks will be run:
		 * 1. `before-highlightall`
		 * 2. `before-all-elements-highlight`
		 * 3. All hooks of {@link Prism.highlightElement} for each element.
		 *
		 * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
		 * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
		 * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
		 * @memberof Prism
		 * @public
		 */
		highlightAllUnder: function (container, async, callback) {
			var env = {
				callback: callback,
				container: container,
				selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
			};

			_.hooks.run('before-highlightall', env);

			env.elements = Array.prototype.slice.apply(env.container.querySelectorAll(env.selector));

			_.hooks.run('before-all-elements-highlight', env);

			for (var i = 0, element; (element = env.elements[i++]);) {
				_.highlightElement(element, async === true, env.callback);
			}
		},

		/**
		 * Highlights the code inside a single element.
		 *
		 * The following hooks will be run:
		 * 1. `before-sanity-check`
		 * 2. `before-highlight`
		 * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
		 * 4. `before-insert`
		 * 5. `after-highlight`
		 * 6. `complete`
		 *
		 * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
		 * the element's language.
		 *
		 * @param {Element} element The element containing the code.
		 * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
		 * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
		 * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
		 * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
		 *
		 * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
		 * asynchronous highlighting to work. You can build your own bundle on the
		 * [Download page](https://prismjs.com/download.html).
		 * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
		 * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
		 * @memberof Prism
		 * @public
		 */
		highlightElement: function (element, async, callback) {
			// Find language
			var language = _.util.getLanguage(element);
			var grammar = _.languages[language];

			// Set language on the element, if not present
			_.util.setLanguage(element, language);

			// Set language on the parent, for styling
			var parent = element.parentElement;
			if (parent && parent.nodeName.toLowerCase() === 'pre') {
				_.util.setLanguage(parent, language);
			}

			var code = element.textContent;

			var env = {
				element: element,
				language: language,
				grammar: grammar,
				code: code
			};

			function insertHighlightedCode(highlightedCode) {
				env.highlightedCode = highlightedCode;

				_.hooks.run('before-insert', env);

				env.element.innerHTML = env.highlightedCode;

				_.hooks.run('after-highlight', env);
				_.hooks.run('complete', env);
				callback && callback.call(env.element);
			}

			_.hooks.run('before-sanity-check', env);

			// plugins may change/add the parent/element
			parent = env.element.parentElement;
			if (parent && parent.nodeName.toLowerCase() === 'pre' && !parent.hasAttribute('tabindex')) {
				parent.setAttribute('tabindex', '0');
			}

			if (!env.code) {
				_.hooks.run('complete', env);
				callback && callback.call(env.element);
				return;
			}

			_.hooks.run('before-highlight', env);

			if (!env.grammar) {
				insertHighlightedCode(_.util.encode(env.code));
				return;
			}

			if (async && _self.Worker) {
				var worker = new Worker(_.filename);

				worker.onmessage = function (evt) {
					insertHighlightedCode(evt.data);
				};

				worker.postMessage(JSON.stringify({
					language: env.language,
					code: env.code,
					immediateClose: true
				}));
			} else {
				insertHighlightedCode(_.highlight(env.code, env.grammar, env.language));
			}
		},

		/**
		 * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
		 * and the language definitions to use, and returns a string with the HTML produced.
		 *
		 * The following hooks will be run:
		 * 1. `before-tokenize`
		 * 2. `after-tokenize`
		 * 3. `wrap`: On each {@link Token}.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @param {string} language The name of the language definition passed to `grammar`.
		 * @returns {string} The highlighted HTML.
		 * @memberof Prism
		 * @public
		 * @example
		 * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
		 */
		highlight: function (text, grammar, language) {
			var env = {
				code: text,
				grammar: grammar,
				language: language
			};
			_.hooks.run('before-tokenize', env);
			if (!env.grammar) {
				throw new Error('The language "' + env.language + '" has no grammar.');
			}
			env.tokens = _.tokenize(env.code, env.grammar);
			_.hooks.run('after-tokenize', env);
			return Token.stringify(_.util.encode(env.tokens), env.language);
		},

		/**
		 * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
		 * and the language definitions to use, and returns an array with the tokenized code.
		 *
		 * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
		 *
		 * This method could be useful in other contexts as well, as a very crude parser.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @returns {TokenStream} An array of strings and tokens, a token stream.
		 * @memberof Prism
		 * @public
		 * @example
		 * let code = `var foo = 0;`;
		 * let tokens = Prism.tokenize(code, Prism.languages.javascript);
		 * tokens.forEach(token => {
		 *     if (token instanceof Prism.Token && token.type === 'number') {
		 *         console.log(`Found numeric literal: ${token.content}`);
		 *     }
		 * });
		 */
		tokenize: function (text, grammar) {
			var rest = grammar.rest;
			if (rest) {
				for (var token in rest) {
					grammar[token] = rest[token];
				}

				delete grammar.rest;
			}

			var tokenList = new LinkedList();
			addAfter(tokenList, tokenList.head, text);

			matchGrammar(text, tokenList, grammar, tokenList.head, 0);

			return toArray(tokenList);
		},

		/**
		 * @namespace
		 * @memberof Prism
		 * @public
		 */
		hooks: {
			all: {},

			/**
			 * Adds the given callback to the list of callbacks for the given hook.
			 *
			 * The callback will be invoked when the hook it is registered for is run.
			 * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
			 *
			 * One callback function can be registered to multiple hooks and the same hook multiple times.
			 *
			 * @param {string} name The name of the hook.
			 * @param {HookCallback} callback The callback function which is given environment variables.
			 * @public
			 */
			add: function (name, callback) {
				var hooks = _.hooks.all;

				hooks[name] = hooks[name] || [];

				hooks[name].push(callback);
			},

			/**
			 * Runs a hook invoking all registered callbacks with the given environment variables.
			 *
			 * Callbacks will be invoked synchronously and in the order in which they were registered.
			 *
			 * @param {string} name The name of the hook.
			 * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
			 * @public
			 */
			run: function (name, env) {
				var callbacks = _.hooks.all[name];

				if (!callbacks || !callbacks.length) {
					return;
				}

				for (var i = 0, callback; (callback = callbacks[i++]);) {
					callback(env);
				}
			}
		},

		Token: Token
	};
	_self.Prism = _;


	// Typescript note:
	// The following can be used to import the Token type in JSDoc:
	//
	//   @typedef {InstanceType<import("./prism-core")["Token"]>} Token

	/**
	 * Creates a new token.
	 *
	 * @param {string} type See {@link Token#type type}
	 * @param {string | TokenStream} content See {@link Token#content content}
	 * @param {string|string[]} [alias] The alias(es) of the token.
	 * @param {string} [matchedStr=""] A copy of the full string this token was created from.
	 * @class
	 * @global
	 * @public
	 */
	function Token(type, content, alias, matchedStr) {
		/**
		 * The type of the token.
		 *
		 * This is usually the key of a pattern in a {@link Grammar}.
		 *
		 * @type {string}
		 * @see GrammarToken
		 * @public
		 */
		this.type = type;
		/**
		 * The strings or tokens contained by this token.
		 *
		 * This will be a token stream if the pattern matched also defined an `inside` grammar.
		 *
		 * @type {string | TokenStream}
		 * @public
		 */
		this.content = content;
		/**
		 * The alias(es) of the token.
		 *
		 * @type {string|string[]}
		 * @see GrammarToken
		 * @public
		 */
		this.alias = alias;
		// Copy of the full string this token was created from
		this.length = (matchedStr || '').length | 0;
	}

	/**
	 * A token stream is an array of strings and {@link Token Token} objects.
	 *
	 * Token streams have to fulfill a few properties that are assumed by most functions (mostly internal ones) that process
	 * them.
	 *
	 * 1. No adjacent strings.
	 * 2. No empty strings.
	 *
	 *    The only exception here is the token stream that only contains the empty string and nothing else.
	 *
	 * @typedef {Array<string | Token>} TokenStream
	 * @global
	 * @public
	 */

	/**
	 * Converts the given token or token stream to an HTML representation.
	 *
	 * The following hooks will be run:
	 * 1. `wrap`: On each {@link Token}.
	 *
	 * @param {string | Token | TokenStream} o The token or token stream to be converted.
	 * @param {string} language The name of current language.
	 * @returns {string} The HTML representation of the token or token stream.
	 * @memberof Token
	 * @static
	 */
	Token.stringify = function stringify(o, language) {
		if (typeof o == 'string') {
			return o;
		}
		if (Array.isArray(o)) {
			var s = '';
			o.forEach(function (e) {
				s += stringify(e, language);
			});
			return s;
		}

		var env = {
			type: o.type,
			content: stringify(o.content, language),
			tag: 'span',
			classes: ['token', o.type],
			attributes: {},
			language: language
		};

		var aliases = o.alias;
		if (aliases) {
			if (Array.isArray(aliases)) {
				Array.prototype.push.apply(env.classes, aliases);
			} else {
				env.classes.push(aliases);
			}
		}

		_.hooks.run('wrap', env);

		var attributes = '';
		for (var name in env.attributes) {
			attributes += ' ' + name + '="' + (env.attributes[name] || '').replace(/"/g, '&quot;') + '"';
		}

		return '<' + env.tag + ' class="' + env.classes.join(' ') + '"' + attributes + '>' + env.content + '</' + env.tag + '>';
	};

	/**
	 * @param {RegExp} pattern
	 * @param {number} pos
	 * @param {string} text
	 * @param {boolean} lookbehind
	 * @returns {RegExpExecArray | null}
	 */
	function matchPattern(pattern, pos, text, lookbehind) {
		pattern.lastIndex = pos;
		var match = pattern.exec(text);
		if (match && lookbehind && match[1]) {
			// change the match to remove the text matched by the Prism lookbehind group
			var lookbehindLength = match[1].length;
			match.index += lookbehindLength;
			match[0] = match[0].slice(lookbehindLength);
		}
		return match;
	}

	/**
	 * @param {string} text
	 * @param {LinkedList<string | Token>} tokenList
	 * @param {any} grammar
	 * @param {LinkedListNode<string | Token>} startNode
	 * @param {number} startPos
	 * @param {RematchOptions} [rematch]
	 * @returns {void}
	 * @private
	 *
	 * @typedef RematchOptions
	 * @property {string} cause
	 * @property {number} reach
	 */
	function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
		for (var token in grammar) {
			if (!grammar.hasOwnProperty(token) || !grammar[token]) {
				continue;
			}

			var patterns = grammar[token];
			patterns = Array.isArray(patterns) ? patterns : [patterns];

			for (var j = 0; j < patterns.length; ++j) {
				if (rematch && rematch.cause == token + ',' + j) {
					return;
				}

				var patternObj = patterns[j];
				var inside = patternObj.inside;
				var lookbehind = !!patternObj.lookbehind;
				var greedy = !!patternObj.greedy;
				var alias = patternObj.alias;

				if (greedy && !patternObj.pattern.global) {
					// Without the global flag, lastIndex won't work
					var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
					patternObj.pattern = RegExp(patternObj.pattern.source, flags + 'g');
				}

				/** @type {RegExp} */
				var pattern = patternObj.pattern || patternObj;

				for ( // iterate the token list and keep track of the current token/string position
					var currentNode = startNode.next, pos = startPos;
					currentNode !== tokenList.tail;
					pos += currentNode.value.length, currentNode = currentNode.next
				) {

					if (rematch && pos >= rematch.reach) {
						break;
					}

					var str = currentNode.value;

					if (tokenList.length > text.length) {
						// Something went terribly wrong, ABORT, ABORT!
						return;
					}

					if (str instanceof Token) {
						continue;
					}

					var removeCount = 1; // this is the to parameter of removeBetween
					var match;

					if (greedy) {
						match = matchPattern(pattern, pos, text, lookbehind);
						if (!match || match.index >= text.length) {
							break;
						}

						var from = match.index;
						var to = match.index + match[0].length;
						var p = pos;

						// find the node that contains the match
						p += currentNode.value.length;
						while (from >= p) {
							currentNode = currentNode.next;
							p += currentNode.value.length;
						}
						// adjust pos (and p)
						p -= currentNode.value.length;
						pos = p;

						// the current node is a Token, then the match starts inside another Token, which is invalid
						if (currentNode.value instanceof Token) {
							continue;
						}

						// find the last node which is affected by this match
						for (
							var k = currentNode;
							k !== tokenList.tail && (p < to || typeof k.value === 'string');
							k = k.next
						) {
							removeCount++;
							p += k.value.length;
						}
						removeCount--;

						// replace with the new match
						str = text.slice(pos, p);
						match.index -= pos;
					} else {
						match = matchPattern(pattern, 0, str, lookbehind);
						if (!match) {
							continue;
						}
					}

					// eslint-disable-next-line no-redeclare
					var from = match.index;
					var matchStr = match[0];
					var before = str.slice(0, from);
					var after = str.slice(from + matchStr.length);

					var reach = pos + str.length;
					if (rematch && reach > rematch.reach) {
						rematch.reach = reach;
					}

					var removeFrom = currentNode.prev;

					if (before) {
						removeFrom = addAfter(tokenList, removeFrom, before);
						pos += before.length;
					}

					removeRange(tokenList, removeFrom, removeCount);

					var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
					currentNode = addAfter(tokenList, removeFrom, wrapped);

					if (after) {
						addAfter(tokenList, currentNode, after);
					}

					if (removeCount > 1) {
						// at least one Token object was removed, so we have to do some rematching
						// this can only happen if the current pattern is greedy

						/** @type {RematchOptions} */
						var nestedRematch = {
							cause: token + ',' + j,
							reach: reach
						};
						matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);

						// the reach might have been extended because of the rematching
						if (rematch && nestedRematch.reach > rematch.reach) {
							rematch.reach = nestedRematch.reach;
						}
					}
				}
			}
		}
	}

	/**
	 * @typedef LinkedListNode
	 * @property {T} value
	 * @property {LinkedListNode<T> | null} prev The previous node.
	 * @property {LinkedListNode<T> | null} next The next node.
	 * @template T
	 * @private
	 */

	/**
	 * @template T
	 * @private
	 */
	function LinkedList() {
		/** @type {LinkedListNode<T>} */
		var head = { value: null, prev: null, next: null };
		/** @type {LinkedListNode<T>} */
		var tail = { value: null, prev: head, next: null };
		head.next = tail;

		/** @type {LinkedListNode<T>} */
		this.head = head;
		/** @type {LinkedListNode<T>} */
		this.tail = tail;
		this.length = 0;
	}

	/**
	 * Adds a new node with the given value to the list.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {T} value
	 * @returns {LinkedListNode<T>} The added node.
	 * @template T
	 */
	function addAfter(list, node, value) {
		// assumes that node != list.tail && values.length >= 0
		var next = node.next;

		var newNode = { value: value, prev: node, next: next };
		node.next = newNode;
		next.prev = newNode;
		list.length++;

		return newNode;
	}
	/**
	 * Removes `count` nodes after the given node. The given node will not be removed.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {number} count
	 * @template T
	 */
	function removeRange(list, node, count) {
		var next = node.next;
		for (var i = 0; i < count && next !== list.tail; i++) {
			next = next.next;
		}
		node.next = next;
		next.prev = node;
		list.length -= i;
	}
	/**
	 * @param {LinkedList<T>} list
	 * @returns {T[]}
	 * @template T
	 */
	function toArray(list) {
		var array = [];
		var node = list.head.next;
		while (node !== list.tail) {
			array.push(node.value);
			node = node.next;
		}
		return array;
	}


	if (!_self.document) {
		if (!_self.addEventListener) {
			// in Node.js
			return _;
		}

		if (!_.disableWorkerMessageHandler) {
			// In worker
			_self.addEventListener('message', function (evt) {
				var message = JSON.parse(evt.data);
				var lang = message.language;
				var code = message.code;
				var immediateClose = message.immediateClose;

				_self.postMessage(_.highlight(code, _.languages[lang], lang));
				if (immediateClose) {
					_self.close();
				}
			}, false);
		}

		return _;
	}

	// Get current script and highlight
	var script = _.util.currentScript();

	if (script) {
		_.filename = script.src;

		if (script.hasAttribute('data-manual')) {
			_.manual = true;
		}
	}

	function highlightAutomaticallyCallback() {
		if (!_.manual) {
			_.highlightAll();
		}
	}

	if (!_.manual) {
		// If the document state is "loading", then we'll use DOMContentLoaded.
		// If the document state is "interactive" and the prism.js script is deferred, then we'll also use the
		// DOMContentLoaded event because there might be some plugins or languages which have also been deferred and they
		// might take longer one animation frame to execute which can create a race condition where only some plugins have
		// been loaded when Prism.highlightAll() is executed, depending on how fast resources are loaded.
		// See https://github.com/PrismJS/prism/issues/2102
		var readyState = document.readyState;
		if (readyState === 'loading' || readyState === 'interactive' && script && script.defer) {
			document.addEventListener('DOMContentLoaded', highlightAutomaticallyCallback);
		} else {
			if (window.requestAnimationFrame) {
				window.requestAnimationFrame(highlightAutomaticallyCallback);
			} else {
				window.setTimeout(highlightAutomaticallyCallback, 16);
			}
		}
	}

	return _;

}(_self));

if (typeof module !== 'undefined' && module.exports) {
	module.exports = Prism;
}

// hack for components to work correctly in node.js
if (typeof global !== 'undefined') {
	global.Prism = Prism;
}

// some additional documentation/types

/**
 * The expansion of a simple `RegExp` literal to support additional properties.
 *
 * @typedef GrammarToken
 * @property {RegExp} pattern The regular expression of the token.
 * @property {boolean} [lookbehind=false] If `true`, then the first capturing group of `pattern` will (effectively)
 * behave as a lookbehind group meaning that the captured text will not be part of the matched text of the new token.
 * @property {boolean} [greedy=false] Whether the token is greedy.
 * @property {string|string[]} [alias] An optional alias or list of aliases.
 * @property {Grammar} [inside] The nested grammar of this token.
 *
 * The `inside` grammar will be used to tokenize the text value of each token of this kind.
 *
 * This can be used to make nested and even recursive language definitions.
 *
 * Note: This can cause infinite recursion. Be careful when you embed different languages or even the same language into
 * each another.
 * @global
 * @public
 */

/**
 * @typedef Grammar
 * @type {Object<string, RegExp | GrammarToken | Array<RegExp | GrammarToken>>}
 * @property {Grammar} [rest] An optional grammar object that will be appended to this grammar.
 * @global
 * @public
 */

/**
 * A function which will invoked after an element was successfully highlighted.
 *
 * @callback HighlightCallback
 * @param {Element} element The element successfully highlighted.
 * @returns {void}
 * @global
 * @public
 */

/**
 * @callback HookCallback
 * @param {Object<string, any>} env The environment variables of the hook.
 * @returns {void}
 * @global
 * @public
 */


/* **********************************************
     Begin prism-markup.js
********************************************** */

Prism.languages.markup = {
	'comment': {
		pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
		greedy: true
	},
	'prolog': {
		pattern: /<\?[\s\S]+?\?>/,
		greedy: true
	},
	'doctype': {
		// https://www.w3.org/TR/xml/#NT-doctypedecl
		pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
		greedy: true,
		inside: {
			'internal-subset': {
				pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
				lookbehind: true,
				greedy: true,
				inside: null // see below
			},
			'string': {
				pattern: /"[^"]*"|'[^']*'/,
				greedy: true
			},
			'punctuation': /^<!|>$|[[\]]/,
			'doctype-tag': /^DOCTYPE/i,
			'name': /[^\s<>'"]+/
		}
	},
	'cdata': {
		pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
		greedy: true
	},
	'tag': {
		pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
		greedy: true,
		inside: {
			'tag': {
				pattern: /^<\/?[^\s>\/]+/,
				inside: {
					'punctuation': /^<\/?/,
					'namespace': /^[^\s>\/:]+:/
				}
			},
			'special-attr': [],
			'attr-value': {
				pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
				inside: {
					'punctuation': [
						{
							pattern: /^=/,
							alias: 'attr-equals'
						},
						{
							pattern: /^(\s*)["']|["']$/,
							lookbehind: true
						}
					]
				}
			},
			'punctuation': /\/?>/,
			'attr-name': {
				pattern: /[^\s>\/]+/,
				inside: {
					'namespace': /^[^\s>\/:]+:/
				}
			}

		}
	},
	'entity': [
		{
			pattern: /&[\da-z]{1,8};/i,
			alias: 'named-entity'
		},
		/&#x?[\da-f]{1,8};/i
	]
};

Prism.languages.markup['tag'].inside['attr-value'].inside['entity'] =
	Prism.languages.markup['entity'];
Prism.languages.markup['doctype'].inside['internal-subset'].inside = Prism.languages.markup;

// Plugin to make entity title show the real entity, idea by Roman Komarov
Prism.hooks.add('wrap', function (env) {

	if (env.type === 'entity') {
		env.attributes['title'] = env.content.replace(/&amp;/, '&');
	}
});

Object.defineProperty(Prism.languages.markup.tag, 'addInlined', {
	/**
	 * Adds an inlined language to markup.
	 *
	 * An example of an inlined language is CSS with `<style>` tags.
	 *
	 * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addInlined('style', 'css');
	 */
	value: function addInlined(tagName, lang) {
		var includedCdataInside = {};
		includedCdataInside['language-' + lang] = {
			pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
			lookbehind: true,
			inside: Prism.languages[lang]
		};
		includedCdataInside['cdata'] = /^<!\[CDATA\[|\]\]>$/i;

		var inside = {
			'included-cdata': {
				pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
				inside: includedCdataInside
			}
		};
		inside['language-' + lang] = {
			pattern: /[\s\S]+/,
			inside: Prism.languages[lang]
		};

		var def = {};
		def[tagName] = {
			pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function () { return tagName; }), 'i'),
			lookbehind: true,
			greedy: true,
			inside: inside
		};

		Prism.languages.insertBefore('markup', 'cdata', def);
	}
});
Object.defineProperty(Prism.languages.markup.tag, 'addAttribute', {
	/**
	 * Adds an pattern to highlight languages embedded in HTML attributes.
	 *
	 * An example of an inlined language is CSS with `style` attributes.
	 *
	 * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addAttribute('style', 'css');
	 */
	value: function (attrName, lang) {
		Prism.languages.markup.tag.inside['special-attr'].push({
			pattern: RegExp(
				/(^|["'\s])/.source + '(?:' + attrName + ')' + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source,
				'i'
			),
			lookbehind: true,
			inside: {
				'attr-name': /^[^\s=]+/,
				'attr-value': {
					pattern: /=[\s\S]+/,
					inside: {
						'value': {
							pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
							lookbehind: true,
							alias: [lang, 'language-' + lang],
							inside: Prism.languages[lang]
						},
						'punctuation': [
							{
								pattern: /^=/,
								alias: 'attr-equals'
							},
							/"|'/
						]
					}
				}
			}
		});
	}
});

Prism.languages.html = Prism.languages.markup;
Prism.languages.mathml = Prism.languages.markup;
Prism.languages.svg = Prism.languages.markup;

Prism.languages.xml = Prism.languages.extend('markup', {});
Prism.languages.ssml = Prism.languages.xml;
Prism.languages.atom = Prism.languages.xml;
Prism.languages.rss = Prism.languages.xml;


/* **********************************************
     Begin prism-css.js
********************************************** */

(function (Prism) {

	var string = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;

	Prism.languages.css = {
		'comment': /\/\*[\s\S]*?\*\//,
		'atrule': {
			pattern: RegExp('@[\\w-](?:' + /[^;{\s"']|\s+(?!\s)/.source + '|' + string.source + ')*?' + /(?:;|(?=\s*\{))/.source),
			inside: {
				'rule': /^@[\w-]+/,
				'selector-function-argument': {
					pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
					lookbehind: true,
					alias: 'selector'
				},
				'keyword': {
					pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
					lookbehind: true
				}
				// See rest below
			}
		},
		'url': {
			// https://drafts.csswg.org/css-values-3/#urls
			pattern: RegExp('\\burl\\((?:' + string.source + '|' + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ')\\)', 'i'),
			greedy: true,
			inside: {
				'function': /^url/i,
				'punctuation': /^\(|\)$/,
				'string': {
					pattern: RegExp('^' + string.source + '$'),
					alias: 'url'
				}
			}
		},
		'selector': {
			pattern: RegExp('(^|[{}\\s])[^{}\\s](?:[^{};"\'\\s]|\\s+(?![\\s{])|' + string.source + ')*(?=\\s*\\{)'),
			lookbehind: true
		},
		'string': {
			pattern: string,
			greedy: true
		},
		'property': {
			pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
			lookbehind: true
		},
		'important': /!important\b/i,
		'function': {
			pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
			lookbehind: true
		},
		'punctuation': /[(){};:,]/
	};

	Prism.languages.css['atrule'].inside.rest = Prism.languages.css;

	var markup = Prism.languages.markup;
	if (markup) {
		markup.tag.addInlined('style', 'css');
		markup.tag.addAttribute('style', 'css');
	}

}(Prism));


/* **********************************************
     Begin prism-clike.js
********************************************** */

Prism.languages.clike = {
	'comment': [
		{
			pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
			lookbehind: true,
			greedy: true
		},
		{
			pattern: /(^|[^\\:])\/\/.*/,
			lookbehind: true,
			greedy: true
		}
	],
	'string': {
		pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
		greedy: true
	},
	'class-name': {
		pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
		lookbehind: true,
		inside: {
			'punctuation': /[.\\]/
		}
	},
	'keyword': /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
	'boolean': /\b(?:false|true)\b/,
	'function': /\b\w+(?=\()/,
	'number': /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
	'operator': /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
	'punctuation': /[{}[\];(),.:]/
};


/* **********************************************
     Begin prism-javascript.js
********************************************** */

Prism.languages.javascript = Prism.languages.extend('clike', {
	'class-name': [
		Prism.languages.clike['class-name'],
		{
			pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
			lookbehind: true
		}
	],
	'keyword': [
		{
			pattern: /((?:^|\})\s*)catch\b/,
			lookbehind: true
		},
		{
			pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
			lookbehind: true
		},
	],
	// Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
	'function': /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
	'number': {
		pattern: RegExp(
			/(^|[^\w$])/.source +
			'(?:' +
			(
				// constant
				/NaN|Infinity/.source +
				'|' +
				// binary integer
				/0[bB][01]+(?:_[01]+)*n?/.source +
				'|' +
				// octal integer
				/0[oO][0-7]+(?:_[0-7]+)*n?/.source +
				'|' +
				// hexadecimal integer
				/0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source +
				'|' +
				// decimal bigint
				/\d+(?:_\d+)*n/.source +
				'|' +
				// decimal number (integer or float) but no bigint
				/(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source
			) +
			')' +
			/(?![\w$])/.source
		),
		lookbehind: true
	},
	'operator': /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
});

Prism.languages.javascript['class-name'][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;

Prism.languages.insertBefore('javascript', 'keyword', {
	'regex': {
		pattern: RegExp(
			// lookbehind
			// eslint-disable-next-line regexp/no-dupe-characters-character-class
			/((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source +
			// Regex pattern:
			// There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
			// classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
			// with the only syntax, so we have to define 2 different regex patterns.
			/\//.source +
			'(?:' +
			/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source +
			'|' +
			// `v` flag syntax. This supports 3 levels of nested character classes.
			/(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source +
			')' +
			// lookahead
			/(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source
		),
		lookbehind: true,
		greedy: true,
		inside: {
			'regex-source': {
				pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
				lookbehind: true,
				alias: 'language-regex',
				inside: Prism.languages.regex
			},
			'regex-delimiter': /^\/|\/$/,
			'regex-flags': /^[a-z]+$/,
		}
	},
	// This must be declared before keyword because we use "function" inside the look-forward
	'function-variable': {
		pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
		alias: 'function'
	},
	'parameter': [
		{
			pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
			lookbehind: true,
			inside: Prism.languages.javascript
		},
		{
			pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
			lookbehind: true,
			inside: Prism.languages.javascript
		},
		{
			pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
			lookbehind: true,
			inside: Prism.languages.javascript
		},
		{
			pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
			lookbehind: true,
			inside: Prism.languages.javascript
		}
	],
	'constant': /\b[A-Z](?:[A-Z_]|\dx?)*\b/
});

Prism.languages.insertBefore('javascript', 'string', {
	'hashbang': {
		pattern: /^#!.*/,
		greedy: true,
		alias: 'comment'
	},
	'template-string': {
		pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
		greedy: true,
		inside: {
			'template-punctuation': {
				pattern: /^`|`$/,
				alias: 'string'
			},
			'interpolation': {
				pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
				lookbehind: true,
				inside: {
					'interpolation-punctuation': {
						pattern: /^\$\{|\}$/,
						alias: 'punctuation'
					},
					rest: Prism.languages.javascript
				}
			},
			'string': /[\s\S]+/
		}
	},
	'string-property': {
		pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
		lookbehind: true,
		greedy: true,
		alias: 'property'
	}
});

Prism.languages.insertBefore('javascript', 'operator', {
	'literal-property': {
		pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
		lookbehind: true,
		alias: 'property'
	},
});

if (Prism.languages.markup) {
	Prism.languages.markup.tag.addInlined('script', 'javascript');

	// add attribute support for all DOM events.
	// https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
	Prism.languages.markup.tag.addAttribute(
		/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source,
		'javascript'
	);
}

Prism.languages.js = Prism.languages.javascript;


/* **********************************************
     Begin prism-file-highlight.js
********************************************** */

(function () {

	if (typeof Prism === 'undefined' || typeof document === 'undefined') {
		return;
	}

	// https://developer.mozilla.org/en-US/docs/Web/API/Element/matches#Polyfill
	if (!Element.prototype.matches) {
		Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
	}

	var LOADING_MESSAGE = 'Loading…';
	var FAILURE_MESSAGE = function (status, message) {
		return '✖ Error ' + status + ' while fetching file: ' + message;
	};
	var FAILURE_EMPTY_MESSAGE = '✖ Error: File does not exist or is empty';

	var EXTENSIONS = {
		'js': 'javascript',
		'py': 'python',
		'rb': 'ruby',
		'ps1': 'powershell',
		'psm1': 'powershell',
		'sh': 'bash',
		'bat': 'batch',
		'h': 'c',
		'tex': 'latex'
	};

	var STATUS_ATTR = 'data-src-status';
	var STATUS_LOADING = 'loading';
	var STATUS_LOADED = 'loaded';
	var STATUS_FAILED = 'failed';

	var SELECTOR = 'pre[data-src]:not([' + STATUS_ATTR + '="' + STATUS_LOADED + '"])'
		+ ':not([' + STATUS_ATTR + '="' + STATUS_LOADING + '"])';

	/**
	 * Loads the given file.
	 *
	 * @param {string} src The URL or path of the source file to load.
	 * @param {(result: string) => void} success
	 * @param {(reason: string) => void} error
	 */
	function loadFile(src, success, error) {
		var xhr = new XMLHttpRequest();
		xhr.open('GET', src, true);
		xhr.onreadystatechange = function () {
			if (xhr.readyState == 4) {
				if (xhr.status < 400 && xhr.responseText) {
					success(xhr.responseText);
				} else {
					if (xhr.status >= 400) {
						error(FAILURE_MESSAGE(xhr.status, xhr.statusText));
					} else {
						error(FAILURE_EMPTY_MESSAGE);
					}
				}
			}
		};
		xhr.send(null);
	}

	/**
	 * Parses the given range.
	 *
	 * This returns a range with inclusive ends.
	 *
	 * @param {string | null | undefined} range
	 * @returns {[number, number | undefined] | undefined}
	 */
	function parseRange(range) {
		var m = /^\s*(\d+)\s*(?:(,)\s*(?:(\d+)\s*)?)?$/.exec(range || '');
		if (m) {
			var start = Number(m[1]);
			var comma = m[2];
			var end = m[3];

			if (!comma) {
				return [start, start];
			}
			if (!end) {
				return [start, undefined];
			}
			return [start, Number(end)];
		}
		return undefined;
	}

	Prism.hooks.add('before-highlightall', function (env) {
		env.selector += ', ' + SELECTOR;
	});

	Prism.hooks.add('before-sanity-check', function (env) {
		var pre = /** @type {HTMLPreElement} */ (env.element);
		if (pre.matches(SELECTOR)) {
			env.code = ''; // fast-path the whole thing and go to complete

			pre.setAttribute(STATUS_ATTR, STATUS_LOADING); // mark as loading

			// add code element with loading message
			var code = pre.appendChild(document.createElement('CODE'));
			code.textContent = LOADING_MESSAGE;

			var src = pre.getAttribute('data-src');

			var language = env.language;
			if (language === 'none') {
				// the language might be 'none' because there is no language set;
				// in this case, we want to use the extension as the language
				var extension = (/\.(\w+)$/.exec(src) || [, 'none'])[1];
				language = EXTENSIONS[extension] || extension;
			}

			// set language classes
			Prism.util.setLanguage(code, language);
			Prism.util.setLanguage(pre, language);

			// preload the language
			var autoloader = Prism.plugins.autoloader;
			if (autoloader) {
				autoloader.loadLanguages(language);
			}

			// load file
			loadFile(
				src,
				function (text) {
					// mark as loaded
					pre.setAttribute(STATUS_ATTR, STATUS_LOADED);

					// handle data-range
					var range = parseRange(pre.getAttribute('data-range'));
					if (range) {
						var lines = text.split(/\r\n?|\n/g);

						// the range is one-based and inclusive on both ends
						var start = range[0];
						var end = range[1] == null ? lines.length : range[1];

						if (start < 0) { start += lines.length; }
						start = Math.max(0, Math.min(start - 1, lines.length));
						if (end < 0) { end += lines.length; }
						end = Math.max(0, Math.min(end, lines.length));

						text = lines.slice(start, end).join('\n');

						// add data-start for line numbers
						if (!pre.hasAttribute('data-start')) {
							pre.setAttribute('data-start', String(start + 1));
						}
					}

					// highlight code
					code.textContent = text;
					Prism.highlightElement(code);
				},
				function (error) {
					// mark as failed
					pre.setAttribute(STATUS_ATTR, STATUS_FAILED);

					code.textContent = error;
				}
			);
		}
	});

	Prism.plugins.fileHighlight = {
		/**
		 * Executes the File Highlight plugin for all matching `pre` elements under the given container.
		 *
		 * Note: Elements which are already loaded or currently loading will not be touched by this method.
		 *
		 * @param {ParentNode} [container=document]
		 */
		highlight: function highlight(container) {
			var elements = (container || document).querySelectorAll(SELECTOR);

			for (var i = 0, element; (element = elements[i++]);) {
				Prism.highlightElement(element);
			}
		}
	};

	var logged = false;
	/** @deprecated Use `Prism.plugins.fileHighlight.highlight` instead. */
	Prism.fileHighlight = function () {
		if (!logged) {
			console.warn('Prism.fileHighlight is deprecated. Use `Prism.plugins.fileHighlight.highlight` instead.');
			logged = true;
		}
		Prism.plugins.fileHighlight.highlight.apply(this, arguments);
	};

}());

!function(e){function n(e,n){return e.replace(/<<(\d+)>>/g,(function(e,s){return"(?:"+n[+s]+")"}))}function s(e,s,a){return RegExp(n(e,s),a||"")}function a(e,n){for(var s=0;s<n;s++)e=e.replace(/<<self>>/g,(function(){return"(?:"+e+")"}));return e.replace(/<<self>>/g,"[^\\s\\S]")}var t="bool byte char decimal double dynamic float int long object sbyte short string uint ulong ushort var void",r="class enum interface record struct",i="add alias and ascending async await by descending from(?=\\s*(?:\\w|$)) get global group into init(?=\\s*;) join let nameof not notnull on or orderby partial remove select set unmanaged value when where with(?=\\s*{)",o="abstract as base break case catch checked const continue default delegate do else event explicit extern finally fixed for foreach goto if implicit in internal is lock namespace new null operator out override params private protected public readonly ref return sealed sizeof stackalloc static switch this throw try typeof unchecked unsafe using virtual volatile while yield";function l(e){return"\\b(?:"+e.trim().replace(/ /g,"|")+")\\b"}var d=l(r),p=RegExp(l(t+" "+r+" "+i+" "+o)),c=l(r+" "+i+" "+o),u=l(t+" "+r+" "+o),g=a("<(?:[^<>;=+\\-*/%&|^]|<<self>>)*>",2),b=a("\\((?:[^()]|<<self>>)*\\)",2),h="@?\\b[A-Za-z_]\\w*\\b",f=n("<<0>>(?:\\s*<<1>>)?",[h,g]),m=n("(?!<<0>>)<<1>>(?:\\s*\\.\\s*<<1>>)*",[c,f]),k="\\[\\s*(?:,\\s*)*\\]",y=n("<<0>>(?:\\s*(?:\\?\\s*)?<<1>>)*(?:\\s*\\?)?",[m,k]),w=n("[^,()<>[\\];=+\\-*/%&|^]|<<0>>|<<1>>|<<2>>",[g,b,k]),v=n("\\(<<0>>+(?:,<<0>>+)+\\)",[w]),x=n("(?:<<0>>|<<1>>)(?:\\s*(?:\\?\\s*)?<<2>>)*(?:\\s*\\?)?",[v,m,k]),$={keyword:p,punctuation:/[<>()?,.:[\]]/},_="'(?:[^\r\n'\\\\]|\\\\.|\\\\[Uux][\\da-fA-F]{1,8})'",B='"(?:\\\\.|[^\\\\"\r\n])*"';e.languages.csharp=e.languages.extend("clike",{string:[{pattern:s("(^|[^$\\\\])<<0>>",['@"(?:""|\\\\[^]|[^\\\\"])*"(?!")']),lookbehind:!0,greedy:!0},{pattern:s("(^|[^@$\\\\])<<0>>",[B]),lookbehind:!0,greedy:!0}],"class-name":[{pattern:s("(\\busing\\s+static\\s+)<<0>>(?=\\s*;)",[m]),lookbehind:!0,inside:$},{pattern:s("(\\busing\\s+<<0>>\\s*=\\s*)<<1>>(?=\\s*;)",[h,x]),lookbehind:!0,inside:$},{pattern:s("(\\busing\\s+)<<0>>(?=\\s*=)",[h]),lookbehind:!0},{pattern:s("(\\b<<0>>\\s+)<<1>>",[d,f]),lookbehind:!0,inside:$},{pattern:s("(\\bcatch\\s*\\(\\s*)<<0>>",[m]),lookbehind:!0,inside:$},{pattern:s("(\\bwhere\\s+)<<0>>",[h]),lookbehind:!0},{pattern:s("(\\b(?:is(?:\\s+not)?|as)\\s+)<<0>>",[y]),lookbehind:!0,inside:$},{pattern:s("\\b<<0>>(?=\\s+(?!<<1>>|with\\s*\\{)<<2>>(?:\\s*[=,;:{)\\]]|\\s+(?:in|when)\\b))",[x,u,h]),inside:$}],keyword:p,number:/(?:\b0(?:x[\da-f_]*[\da-f]|b[01_]*[01])|(?:\B\.\d+(?:_+\d+)*|\b\d+(?:_+\d+)*(?:\.\d+(?:_+\d+)*)?)(?:e[-+]?\d+(?:_+\d+)*)?)(?:[dflmu]|lu|ul)?\b/i,operator:/>>=?|<<=?|[-=]>|([-+&|])\1|~|\?\?=?|[-+*/%&|^!=<>]=?/,punctuation:/\?\.?|::|[{}[\];(),.:]/}),e.languages.insertBefore("csharp","number",{range:{pattern:/\.\./,alias:"operator"}}),e.languages.insertBefore("csharp","punctuation",{"named-parameter":{pattern:s("([(,]\\s*)<<0>>(?=\\s*:)",[h]),lookbehind:!0,alias:"punctuation"}}),e.languages.insertBefore("csharp","class-name",{namespace:{pattern:s("(\\b(?:namespace|using)\\s+)<<0>>(?:\\s*\\.\\s*<<0>>)*(?=\\s*[;{])",[h]),lookbehind:!0,inside:{punctuation:/\./}},"type-expression":{pattern:s("(\\b(?:default|sizeof|typeof)\\s*\\(\\s*(?!\\s))(?:[^()\\s]|\\s(?!\\s)|<<0>>)*(?=\\s*\\))",[b]),lookbehind:!0,alias:"class-name",inside:$},"return-type":{pattern:s("<<0>>(?=\\s+(?:<<1>>\\s*(?:=>|[({]|\\.\\s*this\\s*\\[)|this\\s*\\[))",[x,m]),inside:$,alias:"class-name"},"constructor-invocation":{pattern:s("(\\bnew\\s+)<<0>>(?=\\s*[[({])",[x]),lookbehind:!0,inside:$,alias:"class-name"},"generic-method":{pattern:s("<<0>>\\s*<<1>>(?=\\s*\\()",[h,g]),inside:{function:s("^<<0>>",[h]),generic:{pattern:RegExp(g),alias:"class-name",inside:$}}},"type-list":{pattern:s("\\b((?:<<0>>\\s+<<1>>|record\\s+<<1>>\\s*<<5>>|where\\s+<<2>>)\\s*:\\s*)(?:<<3>>|<<4>>|<<1>>\\s*<<5>>|<<6>>)(?:\\s*,\\s*(?:<<3>>|<<4>>|<<6>>))*(?=\\s*(?:where|[{;]|=>|$))",[d,f,h,x,p.source,b,"\\bnew\\s*\\(\\s*\\)"]),lookbehind:!0,inside:{"record-arguments":{pattern:s("(^(?!new\\s*\\()<<0>>\\s*)<<1>>",[f,b]),lookbehind:!0,greedy:!0,inside:e.languages.csharp},keyword:p,"class-name":{pattern:RegExp(x),greedy:!0,inside:$},punctuation:/[,()]/}},preprocessor:{pattern:/(^[\t ]*)#.*/m,lookbehind:!0,alias:"property",inside:{directive:{pattern:/(#)\b(?:define|elif|else|endif|endregion|error|if|line|nullable|pragma|region|undef|warning)\b/,lookbehind:!0,alias:"keyword"}}}});var E=B+"|"+_,R=n("/(?![*/])|//[^\r\n]*[\r\n]|/\\*(?:[^*]|\\*(?!/))*\\*/|<<0>>",[E]),z=a(n("[^\"'/()]|<<0>>|\\(<<self>>*\\)",[R]),2),S="\\b(?:assembly|event|field|method|module|param|property|return|type)\\b",j=n("<<0>>(?:\\s*\\(<<1>>*\\))?",[m,z]);e.languages.insertBefore("csharp","class-name",{attribute:{pattern:s("((?:^|[^\\s\\w>)?])\\s*\\[\\s*)(?:<<0>>\\s*:\\s*)?<<1>>(?:\\s*,\\s*<<1>>)*(?=\\s*\\])",[S,j]),lookbehind:!0,greedy:!0,inside:{target:{pattern:s("^<<0>>(?=\\s*:)",[S]),alias:"keyword"},"attribute-arguments":{pattern:s("\\(<<0>>*\\)",[z]),inside:e.languages.csharp},"class-name":{pattern:RegExp(m),inside:{punctuation:/\./}},punctuation:/[:,]/}}});var A=":[^}\r\n]+",F=a(n("[^\"'/()]|<<0>>|\\(<<self>>*\\)",[R]),2),P=n("\\{(?!\\{)(?:(?![}:])<<0>>)*<<1>>?\\}",[F,A]),U=a(n("[^\"'/()]|/(?!\\*)|/\\*(?:[^*]|\\*(?!/))*\\*/|<<0>>|\\(<<self>>*\\)",[E]),2),Z=n("\\{(?!\\{)(?:(?![}:])<<0>>)*<<1>>?\\}",[U,A]);function q(n,a){return{interpolation:{pattern:s("((?:^|[^{])(?:\\{\\{)*)<<0>>",[n]),lookbehind:!0,inside:{"format-string":{pattern:s("(^\\{(?:(?![}:])<<0>>)*)<<1>>(?=\\}$)",[a,A]),lookbehind:!0,inside:{punctuation:/^:/}},punctuation:/^\{|\}$/,expression:{pattern:/[\s\S]+/,alias:"language-csharp",inside:e.languages.csharp}}},string:/[\s\S]+/}}e.languages.insertBefore("csharp","string",{"interpolation-string":[{pattern:s('(^|[^\\\\])(?:\\$@|@\\$)"(?:""|\\\\[^]|\\{\\{|<<0>>|[^\\\\{"])*"',[P]),lookbehind:!0,greedy:!0,inside:q(P,F)},{pattern:s('(^|[^@\\\\])\\$"(?:\\\\.|\\{\\{|<<0>>|[^\\\\"{])*"',[Z]),lookbehind:!0,greedy:!0,inside:q(Z,U)}],char:{pattern:RegExp(_),greedy:!0}}),e.languages.dotnet=e.languages.cs=e.languages.csharp}(Prism);
!function(s){var e=/(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;s.languages.css={comment:/\/\*[\s\S]*?\*\//,atrule:{pattern:RegExp("@[\\w-](?:[^;{\\s\"']|\\s+(?!\\s)|"+e.source+")*?(?:;|(?=\\s*\\{))"),inside:{rule:/^@[\w-]+/,"selector-function-argument":{pattern:/(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,lookbehind:!0,alias:"selector"},keyword:{pattern:/(^|[^\w-])(?:and|not|only|or)(?![\w-])/,lookbehind:!0}}},url:{pattern:RegExp("\\burl\\((?:"+e.source+"|(?:[^\\\\\r\n()\"']|\\\\[^])*)\\)","i"),greedy:!0,inside:{function:/^url/i,punctuation:/^\(|\)$/,string:{pattern:RegExp("^"+e.source+"$"),alias:"url"}}},selector:{pattern:RegExp("(^|[{}\\s])[^{}\\s](?:[^{};\"'\\s]|\\s+(?![\\s{])|"+e.source+")*(?=\\s*\\{)"),lookbehind:!0},string:{pattern:e,greedy:!0},property:{pattern:/(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,lookbehind:!0},important:/!important\b/i,function:{pattern:/(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,lookbehind:!0},punctuation:/[(){};:,]/},s.languages.css.atrule.inside.rest=s.languages.css;var t=s.languages.markup;t&&(t.tag.addInlined("style","css"),t.tag.addAttribute("style","css"))}(Prism);
!function(e){e.languages.typescript=e.languages.extend("javascript",{"class-name":{pattern:/(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,lookbehind:!0,greedy:!0,inside:null},builtin:/\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/}),e.languages.typescript.keyword.push(/\b(?:abstract|declare|is|keyof|readonly|require)\b/,/\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/,/\btype\b(?=\s*(?:[\{*]|$))/),delete e.languages.typescript.parameter,delete e.languages.typescript["literal-property"];var s=e.languages.extend("typescript",{});delete s["class-name"],e.languages.typescript["class-name"].inside=s,e.languages.insertBefore("typescript","function",{decorator:{pattern:/@[$\w\xA0-\uFFFF]+/,inside:{at:{pattern:/^@/,alias:"operator"},function:/^[\s\S]+/}},"generic-function":{pattern:/#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,greedy:!0,inside:{function:/^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,generic:{pattern:/<[\s\S]+/,alias:"class-name",inside:s}}}}),e.languages.ts=e.languages.typescript}(Prism);
Prism.languages.python={comment:{pattern:/(^|[^\\])#.*/,lookbehind:!0,greedy:!0},"string-interpolation":{pattern:/(?:f|fr|rf)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i,greedy:!0,inside:{interpolation:{pattern:/((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/,lookbehind:!0,inside:{"format-spec":{pattern:/(:)[^:(){}]+(?=\}$)/,lookbehind:!0},"conversion-option":{pattern:/![sra](?=[:}]$)/,alias:"punctuation"},rest:null}},string:/[\s\S]+/}},"triple-quoted-string":{pattern:/(?:[rub]|br|rb)?("""|''')[\s\S]*?\1/i,greedy:!0,alias:"string"},string:{pattern:/(?:[rub]|br|rb)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i,greedy:!0},function:{pattern:/((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g,lookbehind:!0},"class-name":{pattern:/(\bclass\s+)\w+/i,lookbehind:!0},decorator:{pattern:/(^[\t ]*)@\w+(?:\.\w+)*/m,lookbehind:!0,alias:["annotation","punctuation"],inside:{punctuation:/\./}},keyword:/\b(?:_(?=\s*:)|and|as|assert|async|await|break|case|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|match|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/,builtin:/\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/,boolean:/\b(?:False|None|True)\b/,number:/\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?(?!\w)/i,operator:/[-+%=]=?|!=|:=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,punctuation:/[{}[\];(),.:]/},Prism.languages.python["string-interpolation"].inside.interpolation.inside.rest=Prism.languages.python,Prism.languages.py=Prism.languages.python;
!function(e){var n=/\b(?:abstract|assert|boolean|break|byte|case|catch|char|class|const|continue|default|do|double|else|enum|exports|extends|final|finally|float|for|goto|if|implements|import|instanceof|int|interface|long|module|native|new|non-sealed|null|open|opens|package|permits|private|protected|provides|public|record(?!\s*[(){}[\]<>=%~.:,;?+\-*/&|^])|requires|return|sealed|short|static|strictfp|super|switch|synchronized|this|throw|throws|to|transient|transitive|try|uses|var|void|volatile|while|with|yield)\b/,t="(?:[a-z]\\w*\\s*\\.\\s*)*(?:[A-Z]\\w*\\s*\\.\\s*)*",s={pattern:RegExp("(^|[^\\w.])"+t+"[A-Z](?:[\\d_A-Z]*[a-z]\\w*)?\\b"),lookbehind:!0,inside:{namespace:{pattern:/^[a-z]\w*(?:\s*\.\s*[a-z]\w*)*(?:\s*\.)?/,inside:{punctuation:/\./}},punctuation:/\./}};e.languages.java=e.languages.extend("clike",{string:{pattern:/(^|[^\\])"(?:\\.|[^"\\\r\n])*"/,lookbehind:!0,greedy:!0},"class-name":[s,{pattern:RegExp("(^|[^\\w.])"+t+"[A-Z]\\w*(?=\\s+\\w+\\s*[;,=()]|\\s*(?:\\[[\\s,]*\\]\\s*)?::\\s*new\\b)"),lookbehind:!0,inside:s.inside},{pattern:RegExp("(\\b(?:class|enum|extends|implements|instanceof|interface|new|record|throws)\\s+)"+t+"[A-Z]\\w*\\b"),lookbehind:!0,inside:s.inside}],keyword:n,function:[e.languages.clike.function,{pattern:/(::\s*)[a-z_]\w*/,lookbehind:!0}],number:/\b0b[01][01_]*L?\b|\b0x(?:\.[\da-f_p+-]+|[\da-f_]+(?:\.[\da-f_p+-]+)?)\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfl]?/i,operator:{pattern:/(^|[^.])(?:<<=?|>>>?=?|->|--|\+\+|&&|\|\||::|[?:~]|[-+*/%&|^!=<>]=?)/m,lookbehind:!0},constant:/\b[A-Z][A-Z_\d]+\b/}),e.languages.insertBefore("java","string",{"triple-quoted-string":{pattern:/"""[ \t]*[\r\n](?:(?:"|"")?(?:\\.|[^"\\]))*"""/,greedy:!0,alias:"string"},char:{pattern:/'(?:\\.|[^'\\\r\n]){1,6}'/,greedy:!0}}),e.languages.insertBefore("java","class-name",{annotation:{pattern:/(^|[^.])@\w+(?:\s*\.\s*\w+)*/,lookbehind:!0,alias:"punctuation"},generics:{pattern:/<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&))*>)*>)*>)*>/,inside:{"class-name":s,keyword:n,punctuation:/[<>(),.:]/,operator:/[?&|]/}},import:[{pattern:RegExp("(\\bimport\\s+)"+t+"(?:[A-Z]\\w*|\\*)(?=\\s*;)"),lookbehind:!0,inside:{namespace:s.inside.namespace,punctuation:/\./,operator:/\*/,"class-name":/\w+/}},{pattern:RegExp("(\\bimport\\s+static\\s+)"+t+"(?:\\w+|\\*)(?=\\s*;)"),lookbehind:!0,alias:"static",inside:{namespace:s.inside.namespace,static:/\b\w+$/,punctuation:/\./,operator:/\*/,"class-name":/\w+/}}],namespace:{pattern:RegExp("(\\b(?:exports|import(?:\\s+static)?|module|open|opens|package|provides|requires|to|transitive|uses|with)\\s+)(?!<keyword>)[a-z]\\w*(?:\\.[a-z]\\w*)*\\.?".replace(/<keyword>/g,(function(){return n.source}))),lookbehind:!0,inside:{punctuation:/\./}}})}(Prism);
Prism.languages.json={property:{pattern:/(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/,lookbehind:!0,greedy:!0},string:{pattern:/(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,lookbehind:!0,greedy:!0},comment:{pattern:/\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,greedy:!0},number:/-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,punctuation:/[{}[\],]/,operator:/:/,boolean:/\b(?:false|true)\b/,null:{pattern:/\bnull\b/,alias:"keyword"}},Prism.languages.webmanifest=Prism.languages.json;
Prism.languages.javascript=Prism.languages.extend("clike",{"class-name":[Prism.languages.clike["class-name"],{pattern:/(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,lookbehind:!0}],keyword:[{pattern:/((?:^|\})\s*)catch\b/,lookbehind:!0},{pattern:/(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,lookbehind:!0}],function:/#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,number:{pattern:RegExp("(^|[^\\w$])(?:NaN|Infinity|0[bB][01]+(?:_[01]+)*n?|0[oO][0-7]+(?:_[0-7]+)*n?|0[xX][\\dA-Fa-f]+(?:_[\\dA-Fa-f]+)*n?|\\d+(?:_\\d+)*n|(?:\\d+(?:_\\d+)*(?:\\.(?:\\d+(?:_\\d+)*)?)?|\\.\\d+(?:_\\d+)*)(?:[Ee][+-]?\\d+(?:_\\d+)*)?)(?![\\w$])"),lookbehind:!0},operator:/--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/}),Prism.languages.javascript["class-name"][0].pattern=/(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/,Prism.languages.insertBefore("javascript","keyword",{regex:{pattern:RegExp("((?:^|[^$\\w\\xA0-\\uFFFF.\"'\\])\\s]|\\b(?:return|yield))\\s*)/(?:(?:\\[(?:[^\\]\\\\\r\n]|\\\\.)*\\]|\\\\.|[^/\\\\\\[\r\n])+/[dgimyus]{0,7}|(?:\\[(?:[^[\\]\\\\\r\n]|\\\\.|\\[(?:[^[\\]\\\\\r\n]|\\\\.|\\[(?:[^[\\]\\\\\r\n]|\\\\.)*\\])*\\])*\\]|\\\\.|[^/\\\\\\[\r\n])+/[dgimyus]{0,7}v[dgimyus]{0,7})(?=(?:\\s|/\\*(?:[^*]|\\*(?!/))*\\*/)*(?:$|[\r\n,.;:})\\]]|//))"),lookbehind:!0,greedy:!0,inside:{"regex-source":{pattern:/^(\/)[\s\S]+(?=\/[a-z]*$)/,lookbehind:!0,alias:"language-regex",inside:Prism.languages.regex},"regex-delimiter":/^\/|\/$/,"regex-flags":/^[a-z]+$/}},"function-variable":{pattern:/#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,alias:"function"},parameter:[{pattern:/(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,lookbehind:!0,inside:Prism.languages.javascript},{pattern:/(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,lookbehind:!0,inside:Prism.languages.javascript},{pattern:/(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,lookbehind:!0,inside:Prism.languages.javascript},{pattern:/((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,lookbehind:!0,inside:Prism.languages.javascript}],constant:/\b[A-Z](?:[A-Z_]|\dx?)*\b/}),Prism.languages.insertBefore("javascript","string",{hashbang:{pattern:/^#!.*/,greedy:!0,alias:"comment"},"template-string":{pattern:/`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,greedy:!0,inside:{"template-punctuation":{pattern:/^`|`$/,alias:"string"},interpolation:{pattern:/((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,lookbehind:!0,inside:{"interpolation-punctuation":{pattern:/^\$\{|\}$/,alias:"punctuation"},rest:Prism.languages.javascript}},string:/[\s\S]+/}},"string-property":{pattern:/((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,lookbehind:!0,greedy:!0,alias:"property"}}),Prism.languages.insertBefore("javascript","operator",{"literal-property":{pattern:/((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,lookbehind:!0,alias:"property"}}),Prism.languages.markup&&(Prism.languages.markup.tag.addInlined("script","javascript"),Prism.languages.markup.tag.addAttribute("on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)","javascript")),Prism.languages.js=Prism.languages.javascript;
Prism.languages.go=Prism.languages.extend("clike",{string:{pattern:/(^|[^\\])"(?:\\.|[^"\\\r\n])*"|`[^`]*`/,lookbehind:!0,greedy:!0},keyword:/\b(?:break|case|chan|const|continue|default|defer|else|fallthrough|for|func|go(?:to)?|if|import|interface|map|package|range|return|select|struct|switch|type|var)\b/,boolean:/\b(?:_|false|iota|nil|true)\b/,number:[/\b0(?:b[01_]+|o[0-7_]+)i?\b/i,/\b0x(?:[a-f\d_]+(?:\.[a-f\d_]*)?|\.[a-f\d_]+)(?:p[+-]?\d+(?:_\d+)*)?i?(?!\w)/i,/(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?[\d_]+)?i?(?!\w)/i],operator:/[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\./,builtin:/\b(?:append|bool|byte|cap|close|complex|complex(?:64|128)|copy|delete|error|float(?:32|64)|u?int(?:8|16|32|64)?|imag|len|make|new|panic|print(?:ln)?|real|recover|rune|string|uintptr)\b/}),Prism.languages.insertBefore("go","string",{char:{pattern:/'(?:\\.|[^'\\\r\n]){0,10}'/,greedy:!0}}),delete Prism.languages.go["class-name"];
!function(e){for(var a="/\\*(?:[^*/]|\\*(?!/)|/(?!\\*)|<self>)*\\*/",t=0;t<2;t++)a=a.replace(/<self>/g,(function(){return a}));a=a.replace(/<self>/g,(function(){return"[^\\s\\S]"})),e.languages.rust={comment:[{pattern:RegExp("(^|[^\\\\])"+a),lookbehind:!0,greedy:!0},{pattern:/(^|[^\\:])\/\/.*/,lookbehind:!0,greedy:!0}],string:{pattern:/b?"(?:\\[\s\S]|[^\\"])*"|b?r(#*)"(?:[^"]|"(?!\1))*"\1/,greedy:!0},char:{pattern:/b?'(?:\\(?:x[0-7][\da-fA-F]|u\{(?:[\da-fA-F]_*){1,6}\}|.)|[^\\\r\n\t'])'/,greedy:!0},attribute:{pattern:/#!?\[(?:[^\[\]"]|"(?:\\[\s\S]|[^\\"])*")*\]/,greedy:!0,alias:"attr-name",inside:{string:null}},"closure-params":{pattern:/([=(,:]\s*|\bmove\s*)\|[^|]*\||\|[^|]*\|(?=\s*(?:\{|->))/,lookbehind:!0,greedy:!0,inside:{"closure-punctuation":{pattern:/^\||\|$/,alias:"punctuation"},rest:null}},"lifetime-annotation":{pattern:/'\w+/,alias:"symbol"},"fragment-specifier":{pattern:/(\$\w+:)[a-z]+/,lookbehind:!0,alias:"punctuation"},variable:/\$\w+/,"function-definition":{pattern:/(\bfn\s+)\w+/,lookbehind:!0,alias:"function"},"type-definition":{pattern:/(\b(?:enum|struct|trait|type|union)\s+)\w+/,lookbehind:!0,alias:"class-name"},"module-declaration":[{pattern:/(\b(?:crate|mod)\s+)[a-z][a-z_\d]*/,lookbehind:!0,alias:"namespace"},{pattern:/(\b(?:crate|self|super)\s*)::\s*[a-z][a-z_\d]*\b(?:\s*::(?:\s*[a-z][a-z_\d]*\s*::)*)?/,lookbehind:!0,alias:"namespace",inside:{punctuation:/::/}}],keyword:[/\b(?:Self|abstract|as|async|await|become|box|break|const|continue|crate|do|dyn|else|enum|extern|final|fn|for|if|impl|in|let|loop|macro|match|mod|move|mut|override|priv|pub|ref|return|self|static|struct|super|trait|try|type|typeof|union|unsafe|unsized|use|virtual|where|while|yield)\b/,/\b(?:bool|char|f(?:32|64)|[ui](?:8|16|32|64|128|size)|str)\b/],function:/\b[a-z_]\w*(?=\s*(?:::\s*<|\())/,macro:{pattern:/\b\w+!/,alias:"property"},constant:/\b[A-Z_][A-Z_\d]+\b/,"class-name":/\b[A-Z]\w*\b/,namespace:{pattern:/(?:\b[a-z][a-z_\d]*\s*::\s*)*\b[a-z][a-z_\d]*\s*::(?!\s*<)/,inside:{punctuation:/::/}},number:/\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0o[0-7](?:_?[0-7])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)(?:_?(?:f32|f64|[iu](?:8|16|32|64|size)?))?\b/,boolean:/\b(?:false|true)\b/,punctuation:/->|\.\.=|\.{1,3}|::|[{}[\];(),:]/,operator:/[-+*\/%!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?=?|[@?]/},e.languages.rust["closure-params"].inside.rest=e.languages.rust,e.languages.rust.attribute.inside.string=e.languages.rust.string}(Prism);
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";

;// ../../common/types/api/r2-types.ts
// ---------------------------------------------------------------------------
// Shared R2 AI Chat API types
// Used by both backend (NestJS) and frontend clients.
// ---------------------------------------------------------------------------
var R2ApiResult;
(function (R2ApiResult) {
    R2ApiResult[R2ApiResult["Success"] = 0] = "Success";
    R2ApiResult[R2ApiResult["FailTokenInvalid"] = -1] = "FailTokenInvalid";
    R2ApiResult[R2ApiResult["FailTokenExpired"] = -2] = "FailTokenExpired";
    R2ApiResult[R2ApiResult["FailAccessDenied"] = -3] = "FailAccessDenied";
    R2ApiResult[R2ApiResult["FailServiceTemporaryNotValid"] = -4] = "FailServiceTemporaryNotValid";
    R2ApiResult[R2ApiResult["FailInvalidParameters"] = -5] = "FailInvalidParameters";
})(R2ApiResult || (R2ApiResult = {}));
var R2CopilotsGetResult;
(function (R2CopilotsGetResult) {
    R2CopilotsGetResult[R2CopilotsGetResult["Success"] = 0] = "Success";
    R2CopilotsGetResult[R2CopilotsGetResult["FailTokenInvalid"] = -1] = "FailTokenInvalid";
    R2CopilotsGetResult[R2CopilotsGetResult["FailTokenExpired"] = -2] = "FailTokenExpired";
    R2CopilotsGetResult[R2CopilotsGetResult["FailAccessDenied"] = -3] = "FailAccessDenied";
    R2CopilotsGetResult[R2CopilotsGetResult["FailServiceTemporaryNotValid"] = -4] = "FailServiceTemporaryNotValid";
    R2CopilotsGetResult[R2CopilotsGetResult["FailInvalidParameters"] = -5] = "FailInvalidParameters";
})(R2CopilotsGetResult || (R2CopilotsGetResult = {}));
var R2SendMessageResult;
(function (R2SendMessageResult) {
    R2SendMessageResult[R2SendMessageResult["Success"] = 0] = "Success";
    R2SendMessageResult[R2SendMessageResult["FailTokenInvalid"] = -1] = "FailTokenInvalid";
    R2SendMessageResult[R2SendMessageResult["FailTokenExpired"] = -2] = "FailTokenExpired";
    R2SendMessageResult[R2SendMessageResult["FailAccessDenied"] = -3] = "FailAccessDenied";
    R2SendMessageResult[R2SendMessageResult["FailServiceTemporaryNotValid"] = -4] = "FailServiceTemporaryNotValid";
    R2SendMessageResult[R2SendMessageResult["FailInvalidParameters"] = -5] = "FailInvalidParameters";
    R2SendMessageResult[R2SendMessageResult["FailServiceMaintenance"] = -6] = "FailServiceMaintenance";
    R2SendMessageResult[R2SendMessageResult["FailInsufficientBalance"] = -7] = "FailInsufficientBalance";
})(R2SendMessageResult || (R2SendMessageResult = {}));
/** Result codes for the upstream-only `/api/msg/send/sync` endpoint. */
var R2SendMessageSyncResult;
(function (R2SendMessageSyncResult) {
    R2SendMessageSyncResult[R2SendMessageSyncResult["Success"] = 0] = "Success";
    R2SendMessageSyncResult[R2SendMessageSyncResult["FailTokenInvalid"] = -1] = "FailTokenInvalid";
    R2SendMessageSyncResult[R2SendMessageSyncResult["FailTokenExpired"] = -2] = "FailTokenExpired";
    R2SendMessageSyncResult[R2SendMessageSyncResult["FailAccessDenied"] = -3] = "FailAccessDenied";
    R2SendMessageSyncResult[R2SendMessageSyncResult["FailServiceTemporaryNotValid"] = -4] = "FailServiceTemporaryNotValid";
    R2SendMessageSyncResult[R2SendMessageSyncResult["FailInvalidParameters"] = -5] = "FailInvalidParameters";
    R2SendMessageSyncResult[R2SendMessageSyncResult["FailServiceMaintenance"] = -6] = "FailServiceMaintenance";
    R2SendMessageSyncResult[R2SendMessageSyncResult["FailInsufficientBalance"] = -7] = "FailInsufficientBalance";
})(R2SendMessageSyncResult || (R2SendMessageSyncResult = {}));
var R2AudioTranscribeResult;
(function (R2AudioTranscribeResult) {
    R2AudioTranscribeResult[R2AudioTranscribeResult["Success"] = 0] = "Success";
    R2AudioTranscribeResult[R2AudioTranscribeResult["FailTokenInvalid"] = -1] = "FailTokenInvalid";
    R2AudioTranscribeResult[R2AudioTranscribeResult["FailTokenExpired"] = -2] = "FailTokenExpired";
    R2AudioTranscribeResult[R2AudioTranscribeResult["FailAccessDenied"] = -3] = "FailAccessDenied";
    R2AudioTranscribeResult[R2AudioTranscribeResult["FailServiceTemporaryNotValid"] = -4] = "FailServiceTemporaryNotValid";
    R2AudioTranscribeResult[R2AudioTranscribeResult["FailInvalidParameters"] = -5] = "FailInvalidParameters";
    R2AudioTranscribeResult[R2AudioTranscribeResult["FailServiceMaintenance"] = -6] = "FailServiceMaintenance";
    R2AudioTranscribeResult[R2AudioTranscribeResult["FailInsufficientBalance"] = -7] = "FailInsufficientBalance";
    R2AudioTranscribeResult[R2AudioTranscribeResult["FailModelProcessFileFormat"] = -8] = "FailModelProcessFileFormat";
})(R2AudioTranscribeResult || (R2AudioTranscribeResult = {}));
var R2FileUploadStartResult;
(function (R2FileUploadStartResult) {
    R2FileUploadStartResult[R2FileUploadStartResult["Success"] = 0] = "Success";
    R2FileUploadStartResult[R2FileUploadStartResult["FailTokenInvalid"] = -1] = "FailTokenInvalid";
    R2FileUploadStartResult[R2FileUploadStartResult["FailTokenExpired"] = -2] = "FailTokenExpired";
    R2FileUploadStartResult[R2FileUploadStartResult["FailAccessDenied"] = -3] = "FailAccessDenied";
    R2FileUploadStartResult[R2FileUploadStartResult["FailServiceTemporaryNotValid"] = -4] = "FailServiceTemporaryNotValid";
    R2FileUploadStartResult[R2FileUploadStartResult["FailInvalidParameters"] = -5] = "FailInvalidParameters";
    R2FileUploadStartResult[R2FileUploadStartResult["FailServiceMaintenance"] = -6] = "FailServiceMaintenance";
    R2FileUploadStartResult[R2FileUploadStartResult["FailInsufficientBalance"] = -7] = "FailInsufficientBalance";
    R2FileUploadStartResult[R2FileUploadStartResult["FailFileSize"] = -8] = "FailFileSize";
    R2FileUploadStartResult[R2FileUploadStartResult["FailFilesStorageLimit"] = -9] = "FailFilesStorageLimit";
})(R2FileUploadStartResult || (R2FileUploadStartResult = {}));
var R2FileDownloadStartResult;
(function (R2FileDownloadStartResult) {
    R2FileDownloadStartResult[R2FileDownloadStartResult["Success"] = 0] = "Success";
    R2FileDownloadStartResult[R2FileDownloadStartResult["FailTokenInvalid"] = -1] = "FailTokenInvalid";
    R2FileDownloadStartResult[R2FileDownloadStartResult["FailTokenExpired"] = -2] = "FailTokenExpired";
    R2FileDownloadStartResult[R2FileDownloadStartResult["FailAccessDenied"] = -3] = "FailAccessDenied";
    R2FileDownloadStartResult[R2FileDownloadStartResult["FailServiceTemporaryNotValid"] = -4] = "FailServiceTemporaryNotValid";
    R2FileDownloadStartResult[R2FileDownloadStartResult["FailInvalidParameters"] = -5] = "FailInvalidParameters";
    R2FileDownloadStartResult[R2FileDownloadStartResult["FailServiceMaintenance"] = -6] = "FailServiceMaintenance";
    R2FileDownloadStartResult[R2FileDownloadStartResult["FailInsufficientBalance"] = -7] = "FailInsufficientBalance";
    R2FileDownloadStartResult[R2FileDownloadStartResult["FailFileNotFound"] = -8] = "FailFileNotFound";
})(R2FileDownloadStartResult || (R2FileDownloadStartResult = {}));
var R2FilesGetResult;
(function (R2FilesGetResult) {
    R2FilesGetResult[R2FilesGetResult["Success"] = 0] = "Success";
    R2FilesGetResult[R2FilesGetResult["FailTokenInvalid"] = -1] = "FailTokenInvalid";
    R2FilesGetResult[R2FilesGetResult["FailTokenExpired"] = -2] = "FailTokenExpired";
    R2FilesGetResult[R2FilesGetResult["FailAccessDenied"] = -3] = "FailAccessDenied";
    R2FilesGetResult[R2FilesGetResult["FailServiceTemporaryNotValid"] = -4] = "FailServiceTemporaryNotValid";
    R2FilesGetResult[R2FilesGetResult["FailInvalidParameters"] = -5] = "FailInvalidParameters";
    R2FilesGetResult[R2FilesGetResult["FailServiceMaintenance"] = -6] = "FailServiceMaintenance";
    R2FilesGetResult[R2FilesGetResult["FailInsufficientBalance"] = -7] = "FailInsufficientBalance";
})(R2FilesGetResult || (R2FilesGetResult = {}));
var R2FileGetResult;
(function (R2FileGetResult) {
    R2FileGetResult[R2FileGetResult["SuccessNotFound"] = 1] = "SuccessNotFound";
    R2FileGetResult[R2FileGetResult["Success"] = 0] = "Success";
    R2FileGetResult[R2FileGetResult["FailTokenInvalid"] = -1] = "FailTokenInvalid";
    R2FileGetResult[R2FileGetResult["FailTokenExpired"] = -2] = "FailTokenExpired";
    R2FileGetResult[R2FileGetResult["FailAccessDenied"] = -3] = "FailAccessDenied";
    R2FileGetResult[R2FileGetResult["FailServiceTemporaryNotValid"] = -4] = "FailServiceTemporaryNotValid";
    R2FileGetResult[R2FileGetResult["FailInvalidParameters"] = -5] = "FailInvalidParameters";
    R2FileGetResult[R2FileGetResult["FailServiceMaintenance"] = -6] = "FailServiceMaintenance";
    R2FileGetResult[R2FileGetResult["FailInsufficientBalance"] = -7] = "FailInsufficientBalance";
})(R2FileGetResult || (R2FileGetResult = {}));
var R2FileDeleteResult;
(function (R2FileDeleteResult) {
    R2FileDeleteResult[R2FileDeleteResult["Success"] = 0] = "Success";
    R2FileDeleteResult[R2FileDeleteResult["FailTokenInvalid"] = -1] = "FailTokenInvalid";
    R2FileDeleteResult[R2FileDeleteResult["FailTokenExpired"] = -2] = "FailTokenExpired";
    R2FileDeleteResult[R2FileDeleteResult["FailAccessDenied"] = -3] = "FailAccessDenied";
    R2FileDeleteResult[R2FileDeleteResult["FailServiceTemporaryNotValid"] = -4] = "FailServiceTemporaryNotValid";
    R2FileDeleteResult[R2FileDeleteResult["FailInvalidParameters"] = -5] = "FailInvalidParameters";
    R2FileDeleteResult[R2FileDeleteResult["FailServiceMaintenance"] = -6] = "FailServiceMaintenance";
    R2FileDeleteResult[R2FileDeleteResult["FailInsufficientBalance"] = -7] = "FailInsufficientBalance";
})(R2FileDeleteResult || (R2FileDeleteResult = {}));
var R2FileCheckResult;
(function (R2FileCheckResult) {
    R2FileCheckResult[R2FileCheckResult["Processing"] = 1] = "Processing";
    R2FileCheckResult[R2FileCheckResult["Success"] = 0] = "Success";
    R2FileCheckResult[R2FileCheckResult["FailTokenInvalid"] = -1] = "FailTokenInvalid";
    R2FileCheckResult[R2FileCheckResult["FailTokenExpired"] = -2] = "FailTokenExpired";
    R2FileCheckResult[R2FileCheckResult["FailAccessDenied"] = -3] = "FailAccessDenied";
    R2FileCheckResult[R2FileCheckResult["FailServiceTemporaryNotValid"] = -4] = "FailServiceTemporaryNotValid";
    R2FileCheckResult[R2FileCheckResult["FailInvalidParameters"] = -5] = "FailInvalidParameters";
    R2FileCheckResult[R2FileCheckResult["FailFileNotFound"] = -6] = "FailFileNotFound";
    R2FileCheckResult[R2FileCheckResult["FailOperationNotFound"] = -7] = "FailOperationNotFound";
    R2FileCheckResult[R2FileCheckResult["FailOperationExpired"] = -8] = "FailOperationExpired";
    R2FileCheckResult[R2FileCheckResult["FailInvalidContent"] = -9] = "FailInvalidContent";
})(R2FileCheckResult || (R2FileCheckResult = {}));
var R2MessageMetaType;
(function (R2MessageMetaType) {
    R2MessageMetaType[R2MessageMetaType["QuickAction"] = 0] = "QuickAction";
    R2MessageMetaType[R2MessageMetaType["Skill"] = 1] = "Skill";
})(R2MessageMetaType || (R2MessageMetaType = {}));
// --- Attachments ---
var R2AttachmentType;
(function (R2AttachmentType) {
    R2AttachmentType[R2AttachmentType["Unknown"] = -1] = "Unknown";
    R2AttachmentType[R2AttachmentType["Image"] = 0] = "Image";
    R2AttachmentType[R2AttachmentType["Selection"] = 1] = "Selection";
    R2AttachmentType[R2AttachmentType["File"] = 2] = "File";
})(R2AttachmentType || (R2AttachmentType = {}));
var R2ThreadIdByKeyGetResult;
(function (R2ThreadIdByKeyGetResult) {
    R2ThreadIdByKeyGetResult[R2ThreadIdByKeyGetResult["SuccessNotFound"] = 1] = "SuccessNotFound";
    R2ThreadIdByKeyGetResult[R2ThreadIdByKeyGetResult["Success"] = 0] = "Success";
    R2ThreadIdByKeyGetResult[R2ThreadIdByKeyGetResult["FailTokenInvalid"] = -1] = "FailTokenInvalid";
    R2ThreadIdByKeyGetResult[R2ThreadIdByKeyGetResult["FailTokenExpired"] = -2] = "FailTokenExpired";
    R2ThreadIdByKeyGetResult[R2ThreadIdByKeyGetResult["FailAccessDenied"] = -3] = "FailAccessDenied";
    R2ThreadIdByKeyGetResult[R2ThreadIdByKeyGetResult["FailServiceTemporaryNotValid"] = -4] = "FailServiceTemporaryNotValid";
    R2ThreadIdByKeyGetResult[R2ThreadIdByKeyGetResult["FailInvalidParameters"] = -5] = "FailInvalidParameters";
})(R2ThreadIdByKeyGetResult || (R2ThreadIdByKeyGetResult = {}));
// --- sellcode/apply ---
var R2SellcodeApplyResult;
(function (R2SellcodeApplyResult) {
    R2SellcodeApplyResult[R2SellcodeApplyResult["Success"] = 0] = "Success";
    R2SellcodeApplyResult[R2SellcodeApplyResult["FailTokenInvalid"] = -1] = "FailTokenInvalid";
    R2SellcodeApplyResult[R2SellcodeApplyResult["FailTokenExpired"] = -2] = "FailTokenExpired";
    R2SellcodeApplyResult[R2SellcodeApplyResult["FailAccessDenied"] = -3] = "FailAccessDenied";
    R2SellcodeApplyResult[R2SellcodeApplyResult["FailServiceTemporaryNotValid"] = -4] = "FailServiceTemporaryNotValid";
    R2SellcodeApplyResult[R2SellcodeApplyResult["FailInvalidParameters"] = -5] = "FailInvalidParameters";
    R2SellcodeApplyResult[R2SellcodeApplyResult["FailAlreadyApplied"] = -6] = "FailAlreadyApplied";
    R2SellcodeApplyResult[R2SellcodeApplyResult["FailExhausted"] = -7] = "FailExhausted";
    R2SellcodeApplyResult[R2SellcodeApplyResult["FailInactive"] = -8] = "FailInactive";
    R2SellcodeApplyResult[R2SellcodeApplyResult["FailNotFound"] = -9] = "FailNotFound";
})(R2SellcodeApplyResult || (R2SellcodeApplyResult = {}));
// --- key/generate, keys/get, key/delete ---
var R2ApiKeyGenerateResult;
(function (R2ApiKeyGenerateResult) {
    R2ApiKeyGenerateResult[R2ApiKeyGenerateResult["Success"] = 0] = "Success";
    R2ApiKeyGenerateResult[R2ApiKeyGenerateResult["FailTokenInvalid"] = -1] = "FailTokenInvalid";
    R2ApiKeyGenerateResult[R2ApiKeyGenerateResult["FailTokenExpired"] = -2] = "FailTokenExpired";
    R2ApiKeyGenerateResult[R2ApiKeyGenerateResult["FailAccessDenied"] = -3] = "FailAccessDenied";
    R2ApiKeyGenerateResult[R2ApiKeyGenerateResult["FailServiceTemporaryNotValid"] = -4] = "FailServiceTemporaryNotValid";
    R2ApiKeyGenerateResult[R2ApiKeyGenerateResult["FailInvalidParameters"] = -5] = "FailInvalidParameters";
    R2ApiKeyGenerateResult[R2ApiKeyGenerateResult["FailServiceMaintenance"] = -6] = "FailServiceMaintenance";
    R2ApiKeyGenerateResult[R2ApiKeyGenerateResult["FailLimitReached"] = -7] = "FailLimitReached";
})(R2ApiKeyGenerateResult || (R2ApiKeyGenerateResult = {}));
var R2ApiKeyDeleteResult;
(function (R2ApiKeyDeleteResult) {
    /** The key was already gone; the caller's intent is satisfied. */
    R2ApiKeyDeleteResult[R2ApiKeyDeleteResult["SuccessNotFound"] = 1] = "SuccessNotFound";
    R2ApiKeyDeleteResult[R2ApiKeyDeleteResult["Success"] = 0] = "Success";
    R2ApiKeyDeleteResult[R2ApiKeyDeleteResult["FailTokenInvalid"] = -1] = "FailTokenInvalid";
    R2ApiKeyDeleteResult[R2ApiKeyDeleteResult["FailTokenExpired"] = -2] = "FailTokenExpired";
    R2ApiKeyDeleteResult[R2ApiKeyDeleteResult["FailAccessDenied"] = -3] = "FailAccessDenied";
    R2ApiKeyDeleteResult[R2ApiKeyDeleteResult["FailServiceTemporaryNotValid"] = -4] = "FailServiceTemporaryNotValid";
    R2ApiKeyDeleteResult[R2ApiKeyDeleteResult["FailInvalidParameters"] = -5] = "FailInvalidParameters";
})(R2ApiKeyDeleteResult || (R2ApiKeyDeleteResult = {}));
var R2ContactClient;
(function (R2ContactClient) {
    R2ContactClient["Web"] = "Web";
    R2ContactClient["OfficeWeb"] = "Office Web";
    R2ContactClient["OfficeDesktop"] = "Office Desktop";
    R2ContactClient["GoogleDocs"] = "Google Docs";
    R2ContactClient["GoogleSheets"] = "Google Sheets";
})(R2ContactClient || (R2ContactClient = {}));

;// ./src/errors.ts
var _a;
var ERROR_NAME = {
    SESSION_NOT_FOUND: 'CHAT.ERR-SESS-NOT-FOUND',
    SUBSCRIPTION_NOT_FOUND: 'CHAT.ERR-SUBS-NOT-FOUND',
    SUBSCRIPTION_INACTIVE: 'CHAT.ERR-SUBS-INACTIVE',
    SUBSCRIPTION_EXPIRED: 'CHAT.ERR-SUBS-EXPIRED',
    SUBSCRIPTION_LIMIT_FOR_USER: 'CHAT.ERR-SUBS-NO-USERS',
    SUBSCRIPTION_LIMIT_FOR_TOKENS: 'CHAT.ERR-SUBS-NO-TOKENS',
    REQUEST_TIMEOUT: 'CHAT.ERR-TIMEOUT',
    UNKNOWN_ERROR: 'CHAT.ERR-UNKNOWN',
    SERVICE_MAINTENANCE: 'CHAT.ERR-SERVICE-MAINTENANCE',
    INSUFFICIENT_TOKENS: 'CHAT.ERR-INSUFFICIENT-TOKENS',
    GUIDELINES: 'CHAT.ERR-MSG1',
    INAPPROPRIATE_TOPICS: 'CHAT.ERR-MSG2',
    HIGH_TRAFFIC: 'CHAT.ERR-MSG3'
};
var ERROR_MESSAGE = (_a = {},
    _a[ERROR_NAME.SESSION_NOT_FOUND] = 'To continue using R2 services, login or re-login is required.',
    _a[ERROR_NAME.SUBSCRIPTION_NOT_FOUND] = 'Oops! R2 couldn\'t find your subscription. Please make sure you signed in with the correct account.',
    _a[ERROR_NAME.SUBSCRIPTION_INACTIVE] = 'Uh-oh! It seems like your subscription isn\'t active at the moment. Please renew your subscription to continue accessing R2 services.',
    _a[ERROR_NAME.SUBSCRIPTION_EXPIRED] = 'Oh dear! Your subscription has expired. Please consider renewing it to regain access to R2 services.',
    _a[ERROR_NAME.SUBSCRIPTION_LIMIT_FOR_USER] = 'Looks like you\'ve reached the maximum number of users allowed for your subscription. Consider upgrading your plan.',
    _a[ERROR_NAME.SUBSCRIPTION_LIMIT_FOR_TOKENS] = 'Oops! You\'ve used up all your subscription tokens. Get a new subscription for more tokens.',
    _a[ERROR_NAME.REQUEST_TIMEOUT] = 'R2 cannot generate a reply to your request as it has exceeded the processing time limit.',
    _a[ERROR_NAME.UNKNOWN_ERROR] = 'Unknown error',
    _a[ERROR_NAME.SERVICE_MAINTENANCE] = 'R2 is temporarily unavailable for maintenance. Please try again shortly.',
    _a[ERROR_NAME.INSUFFICIENT_TOKENS] = 'Insufficient token balance.',
    _a[ERROR_NAME.GUIDELINES] = 'I am sorry, but I cannot provide you with the answer to this question. It is against my guidelines to help you respond to questions of sexuality, violence, hate, and self-harm. I encourage you to maintain a safe and respectful conversation environment. If you have other questions or need help with other topics, I will be happy to be of assistance.',
    _a[ERROR_NAME.INAPPROPRIATE_TOPICS] = 'I am sorry, but I cannot respond to or comment on inappropriate topics, including topics that are sexual, violent, hateful, or self-harming. My goal is to help, educate, and have positive and respectful conversations. If you have other questions or need help with another topic, please feel free to ask. I\'m happy to help.',
    _a[ERROR_NAME.HIGH_TRAFFIC] = 'Oops! It seems our system is experiencing a high volume of traffic right now. Please take a moment and try again shortly. We appreciate your patience!',
    _a);
var getErrorText = function (errorName) { return ERROR_MESSAGE[errorName]; };

;// ./src/office.ts
var Office = window.Office;
/* harmony default export */ const office = (Office);


;// ../src/app/services/session-crypto/office-api-routes.ts
/** The Office transport facade's finite set of shared API operations. */
var routes = {
    'GET /copilots': { plain: '/api/copilot/copilots', secure: '/api/secure/copilot/copilots' },
    'POST /sellcode/apply': { plain: '/api/copilot/sellcode/apply', secure: '/api/secure/copilot/sellcode/apply' },
    'POST /subscription/user-subscription': { plain: '/api/subscription/user-subscription', secure: '/api/secure/subscription/user-subscription' },
    'POST /msg/send': { plain: '/api/r2-chat/msg/send', secure: '/api/secure/r2-chat/msg/send' },
    'POST /msgs/get': { plain: '/api/r2-chat/msgs/get', secure: '/api/secure/r2-chat/msgs/get' },
    'POST /thread/create-if-not-exists': { plain: '/api/r2-chat/thread/create-if-not-exists', secure: '/api/secure/r2-chat/thread/create-if-not-exists' },
    'POST /thread/id/assign': { plain: '/api/r2-chat/thread/id/assign', secure: '/api/secure/r2-chat/thread/id/assign' },
    'POST /thread/delete': { plain: '/api/r2-chat/thread/delete', secure: '/api/secure/r2-chat/thread/delete' },
    'POST /thread/msg/delete': { plain: '/api/r2-chat/thread/msg/delete', secure: '/api/secure/r2-chat/thread/msg/delete' },
    'POST /group-chat/user/msg/add': { plain: '/api/group-chat/user/msg/add', secure: '/api/secure/group-chat/user/msg/add' },
    'POST /group-chat/user/msgs/get': { plain: '/api/group-chat/user/msgs/get', secure: '/api/secure/group-chat/user/msgs/get' },
    'POST /group-chat/user/msg/get': { plain: '/api/group-chat/user/msg/get', secure: '/api/secure/group-chat/user/msg/get' },
    'POST /group-chat/users/get': { plain: '/api/group-chat/users/get', secure: '/api/secure/group-chat/users/get' },
    'POST /group-chat/user/msg/delete': { plain: '/api/group-chat/user/msg/delete', secure: '/api/secure/group-chat/user/msg/delete' },
    'POST /group-chat/user/msgs/delete/all': { plain: '/api/group-chat/user/msgs/delete/all', secure: '/api/secure/group-chat/user/msgs/delete/all' },
    'POST /audio/transcribe': { plain: '/api/audio/transcribe', secure: '/api/secure/audio/transcribe' },
    'GET /file/limits/get': { plain: '/api/file/limits/get', secure: '/api/secure/file/limits/get' },
    'POST /file/upload/start': { plain: '/api/file/upload/start', secure: '/api/secure/file/upload/start' },
    'POST /file/upload/check': { plain: '/api/file/upload/check', secure: '/api/secure/file/upload/check' },
    'POST /file/download/start': { plain: '/api/file/download/start', secure: '/api/secure/file/download/start' },
    'POST /file/download/check': { plain: '/api/file/download/check', secure: '/api/secure/file/download/check' },
    'POST /skills/unwrap': { plain: '/api/v2/r2-chat/skills/unwrap' },
    'POST /v3/skills/unwrap': { plain: '/api/v3/r2-chat/skills/unwrap' },
    'POST /contacts/support': { plain: '/api/contacts/support' },
    'POST /contacts/report-issue': { plain: '/api/contacts/report-issue' },
    'GET /models': { plain: '/api/r2-chat/models' },
    'GET /user/settings': { plain: '/api/r2-chat/user/settings' },
    'GET /skills': { plain: '/api/v2/r2-chat/skills' },
    'GET /skill-tags': { plain: '/api/r2-chat/skill-tags' },
    'GET /instructions': { plain: '/api/v2/r2-chat/instructions' },
    'GET /locales': { plain: '/api/r2-chat/locales' },
    'GET /message-history-presets': { plain: '/api/r2-chat/message-history-presets' },
    'GET /answer-lengths': { plain: '/api/r2-chat/answer-lengths' },
    'GET /chat-defaults': { plain: '/api/r2-chat/chat-defaults' },
};
function officeApiRoute(method, path, secure) {
    var destination = routes["".concat(method, " ").concat(path)];
    if (!destination || (secure && !destination.secure))
        throw new Error("Unsupported Office API operation: ".concat(method, " ").concat(path));
    return secure ? destination.secure : destination.plain;
}

;// ../../common/transport/session-crypto.ts
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var DECRYPT_ERROR_MESSAGE = 'Failed to decrypt secure payload';
var MISSING_ENCRYPTED_DATA_MESSAGE = 'Secure API response does not contain encrypted data';
/** Existing upstream wire protocol. No HTTP, storage, session policy or retries live here. */
function generateEcdhKeyPair(subtle) {
    if (subtle === void 0) { subtle = crypto.subtle; }
    return __awaiter(this, void 0, Promise, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 4]);
                    return [4 /*yield*/, subtle.generateKey({ name: 'ECDH', namedCurve: 'P-521' }, false, ['deriveBits'])];
                case 1: return [2 /*return*/, _b.sent()];
                case 2:
                    _a = _b.sent();
                    return [4 /*yield*/, subtle.generateKey({ name: 'ECDH', namedCurve: 'P-521' }, true, ['deriveBits'])];
                case 3: return [2 /*return*/, _b.sent()];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function exportPublicKey(publicKey, subtle) {
    if (subtle === void 0) { subtle = crypto.subtle; }
    return __awaiter(this, void 0, Promise, function () {
        var bytes, _a, binary, index;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = Uint8Array.bind;
                    return [4 /*yield*/, subtle.exportKey('raw', publicKey)];
                case 1:
                    bytes = new (_a.apply(Uint8Array, [void 0, _b.sent()]))();
                    binary = '';
                    for (index = 0; index < bytes.length; index++)
                        binary += String.fromCharCode(bytes[index]);
                    return [2 /*return*/, btoa(binary)];
            }
        });
    });
}
/** Preserve the established left-padding/trailing-byte P-521 normalization. */
function normalizeP521Secret(buffer) {
    var secret = new Uint8Array(buffer);
    if (secret.length === 66)
        return secret;
    if (secret.length > 66)
        return secret.slice(secret.length - 66);
    var padded = new Uint8Array(66);
    padded.set(secret, 66 - secret.length);
    return padded;
}
function deriveSessionMaterials(privateKey, serverPublicKey, subtle) {
    if (subtle === void 0) { subtle = crypto.subtle; }
    return __awaiter(this, void 0, Promise, function () {
        var binary, raw, index, serverKey, bits, secret, counter, digest, key;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!serverPublicKey)
                        throw new Error('Server public key is missing in key/set response');
                    binary = atob(serverPublicKey);
                    raw = new Uint8Array(binary.length);
                    for (index = 0; index < binary.length; index++)
                        raw[index] = binary.charCodeAt(index);
                    return [4 /*yield*/, subtle.importKey('raw', raw, { name: 'ECDH', namedCurve: 'P-521' }, true, [])];
                case 1:
                    serverKey = _a.sent();
                    return [4 /*yield*/, subtle.deriveBits({ name: 'ECDH', public: serverKey }, privateKey, null)];
                case 2:
                    bits = _a.sent();
                    secret = normalizeP521Secret(bits);
                    counter = copyBuffer(secret.slice(0, 16));
                    return [4 /*yield*/, subtle.digest('SHA-256', copyBuffer(secret.slice(16, 66)))];
                case 3:
                    digest = _a.sent();
                    return [4 /*yield*/, subtle.importKey('raw', digest, { name: 'AES-CTR', length: 256 }, false, ['encrypt', 'decrypt'])];
                case 4:
                    key = _a.sent();
                    return [2 /*return*/, { key: key, counter: counter }];
            }
        });
    });
}
function encryptPayload(body, materials, subtle) {
    if (subtle === void 0) { subtle = crypto.subtle; }
    return __awaiter(this, void 0, Promise, function () {
        var plainBytes, encrypted;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (body == null)
                        return [2 /*return*/, ''];
                    plainBytes = new TextEncoder().encode(JSON.stringify(body));
                    return [4 /*yield*/, subtle.encrypt({ name: 'AES-CTR', counter: materials.counter, length: 128 }, materials.key, plainBytes)];
                case 1:
                    encrypted = _a.sent();
                    return [2 /*return*/, Array.from(new Uint8Array(encrypted), function (value) { return value.toString(16).padStart(2, '0'); }).join('')];
            }
        });
    });
}
function decryptPayload(hexData, materials, subtle) {
    if (subtle === void 0) { subtle = crypto.subtle; }
    return __awaiter(this, void 0, Promise, function () {
        var normalized, encryptedBytes, index, decrypted, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!hexData)
                        return [2 /*return*/, {}];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    normalized = hexData.trim();
                    if (normalized.length % 2 !== 0 || !/^[0-9a-fA-F]+$/.test(normalized)) {
                        throw new Error('Invalid hex payload');
                    }
                    encryptedBytes = new Uint8Array(normalized.length / 2);
                    for (index = 0; index < normalized.length; index += 2) {
                        encryptedBytes[index / 2] = Number.parseInt(normalized.slice(index, index + 2), 16);
                    }
                    return [4 /*yield*/, subtle.decrypt({ name: 'AES-CTR', counter: materials.counter, length: 128 }, materials.key, encryptedBytes)];
                case 2:
                    decrypted = _a.sent();
                    return [2 /*return*/, JSON.parse(new TextDecoder().decode(decrypted))];
                case 3:
                    error_1 = _a.sent();
                    throw new Error(DECRYPT_ERROR_MESSAGE, { cause: error_1 });
                case 4: return [2 /*return*/];
            }
        });
    });
}
function encryptedEnvelopeData(response) {
    var data = response && typeof response === 'object' ? response.data : undefined;
    if (typeof data !== 'string' || data.trim().length === 0) {
        throw new Error(MISSING_ENCRYPTED_DATA_MESSAGE);
    }
    return data;
}
function copyBuffer(bytes) {
    var copy = new Uint8Array(bytes.byteLength);
    copy.set(bytes);
    return copy.buffer;
}

;// ../../common/types/api/session-crypto.types.ts
var TRANSPORT_CONTRACT_HEADER = 'x-r2-transport-contract';
var TRANSPORT_CONTEXT_HEADER = 'x-r2-transport-context';
var TRANSPORT_CONTRACT_VERSION = '1';

;// ./src/signed-session.ts
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var signed_session_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var signed_session_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var SESSION_KEY = 'r2_office_signed_session';
var EPOCH_KEY = 'r2_office_session_epoch';
var SIGNED_IN_ONCE_KEY = 'r2_office_signed_in_once';
var ROTATION_MARGIN_MS = 120000;
var legacyExchangeWork = new WeakMap();
function loggedOut(storage) {
    return storage.getItem('r2_office_logged_out') === 'true'
        || storage.getItem('r2_msal_logged_out') === 'true';
}
function preferredAccount(storage) {
    var _a;
    var raw = (_a = storage.getItem('r2_office_preferred_account')) !== null && _a !== void 0 ? _a : storage.getItem('r2_msal_preferred_account');
    return preferredAccountFromRaw(raw);
}
function preferredAccountFromRaw(raw) {
    if (!raw)
        return null;
    try {
        var value = JSON.parse(raw);
        if (typeof (value === null || value === void 0 ? void 0 : value.subject) !== 'string' || !value.subject
            || typeof value.tenantId !== 'string' || !value.tenantId
            || (value.loginHint !== undefined && typeof value.loginHint !== 'string'))
            return undefined;
        return value;
    }
    catch (_a) {
        return undefined;
    }
}
function storedSession(apiHost, storage) {
    var _a, _b;
    var raw = storage.getItem(SESSION_KEY);
    if (!raw)
        return null;
    try {
        var value = JSON.parse(raw);
        if ((value === null || value === void 0 ? void 0 : value.version) !== 1 || value.apiHost !== apiHost
            || typeof value.sessionToken !== 'string' || !value.sessionToken
            || !Number.isSafeInteger(value.expiresAt)
            || typeof ((_a = value.account) === null || _a === void 0 ? void 0 : _a.subject) !== 'string' || !value.account.subject
            || typeof ((_b = value.account) === null || _b === void 0 ? void 0 : _b.tenantId) !== 'string' || !value.account.tenantId
            || (value.account.email !== null && typeof value.account.email !== 'string')
            || (value.account.displayName !== null && typeof value.account.displayName !== 'string'))
            return null;
        return value;
    }
    catch (_c) {
        return null;
    }
}
function accountIsCurrent(session, storage) {
    if (loggedOut(storage))
        return false;
    var preferred = preferredAccount(storage);
    return preferred !== undefined && (!preferred
        || (preferred.tenantId === session.account.tenantId && preferred.subject === session.account.subject));
}
function sameAccount(left, right) {
    return left !== undefined && right !== undefined && (!left ? !right
        : !!right && left.subject === right.subject && left.tenantId === right.tenantId);
}
function concurrentSignedToken(apiHost, storage, now, epoch, sourceRaw, preferred, legacyPair, expected) {
    var currentSessionId = storage.getItem('session_id');
    var currentDeviceHash = storage.getItem('device_hash');
    var pairUnchanged = currentSessionId === legacyPair.sessionId
        && currentDeviceHash === legacyPair.deviceHash;
    var pairRetired = !currentSessionId && !currentDeviceHash;
    if (storage.getItem(EPOCH_KEY) !== epoch || loggedOut(storage)
        || !sameAccount(preferred, preferredAccount(storage))
        || (!pairUnchanged && !pairRetired) || storage.getItem(SESSION_KEY) === sourceRaw)
        return null;
    var current = storedSession(apiHost, storage);
    if (!current || current.expiresAt <= now() || !accountIsCurrent(current, storage)
        || (expected && (current.account.subject !== expected.subject
            || current.account.tenantId !== expected.tenantId)))
        return null;
    return current.sessionToken;
}
function exchangeLegacyOnce(apiHost, storage, now, fetcher, epoch) {
    var byHost = legacyExchangeWork.get(storage);
    if (!byHost) {
        byHost = new Map();
        legacyExchangeWork.set(storage, byHost);
    }
    var key = JSON.stringify([apiHost, epoch]);
    var pending = byHost.get(key);
    if (pending)
        return pending;
    var work = exchangeLegacy(apiHost, storage, now, fetcher, epoch);
    byHost.set(key, work);
    void work.then(function () { if ((byHost === null || byHost === void 0 ? void 0 : byHost.get(key)) === work)
        byHost.delete(key); }, function () { if ((byHost === null || byHost === void 0 ? void 0 : byHost.get(key)) === work)
        byHost.delete(key); });
    return work;
}
function exchangeLegacy(apiHost, storage, now, fetcher, epoch) {
    var _a, _b, _c;
    return signed_session_awaiter(this, void 0, Promise, function () {
        var sourceRaw, sessionId, deviceHash, preferred, current, response, successor, _d, concurrent, next;
        return signed_session_generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (loggedOut(storage) || storage.getItem(EPOCH_KEY) !== epoch)
                        return [2 /*return*/, null];
                    sourceRaw = storage.getItem(SESSION_KEY);
                    sessionId = storage.getItem('session_id');
                    deviceHash = storage.getItem('device_hash');
                    preferred = preferredAccount(storage);
                    if (preferred === undefined)
                        return [2 /*return*/, null];
                    if (!sessionId || !deviceHash) {
                        current = storedSession(apiHost, storage);
                        return [2 /*return*/, current && current.expiresAt > now() && accountIsCurrent(current, storage)
                                ? current.sessionToken : null];
                    }
                    if (!preferred && storage.getItem(SIGNED_IN_ONCE_KEY) === 'true')
                        return [2 /*return*/, null];
                    return [4 /*yield*/, fetcher("".concat(apiHost, "/api/auth/session/exchange"), {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify(__assign({ provider: 'microsoft', session_id: sessionId, device_hash: deviceHash }, (preferred ? { expectedAccount: { subject: preferred.subject, tenantId: preferred.tenantId } } : {}))),
                        })];
                case 1:
                    response = _e.sent();
                    if (response.status === 401 || response.status === 403)
                        return [2 /*return*/, concurrentSignedToken(apiHost, storage, now, epoch, sourceRaw, preferred, { sessionId: sessionId, deviceHash: deviceHash })];
                    if (!response.ok)
                        throw new Error("Office session exchange failed: HTTP ".concat(response.status));
                    _e.label = 2;
                case 2:
                    _e.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, response.json()];
                case 3:
                    successor = (_e.sent());
                    return [3 /*break*/, 5];
                case 4:
                    _d = _e.sent();
                    return [2 /*return*/, null];
                case 5:
                    if (typeof (successor === null || successor === void 0 ? void 0 : successor.sessionToken) !== 'string' || !successor.sessionToken
                        || !Number.isSafeInteger(successor.expiresAt) || successor.expiresAt <= now()
                        || ((_a = successor.account) === null || _a === void 0 ? void 0 : _a.provider) !== 'microsoft'
                        || typeof successor.account.subject !== 'string' || !successor.account.subject
                        || typeof successor.account.tenantId !== 'string' || !successor.account.tenantId
                        || (successor.account.email != null && typeof successor.account.email !== 'string')
                        || (successor.account.displayName != null && typeof successor.account.displayName !== 'string')
                        || (preferred && (successor.account.subject !== preferred.subject
                            || successor.account.tenantId !== preferred.tenantId)))
                        return [2 /*return*/, null];
                    concurrent = concurrentSignedToken(apiHost, storage, now, epoch, sourceRaw, preferred, { sessionId: sessionId, deviceHash: deviceHash }, { subject: successor.account.subject, tenantId: successor.account.tenantId });
                    if (concurrent)
                        return [2 /*return*/, concurrent];
                    if (storage.getItem(EPOCH_KEY) !== epoch || loggedOut(storage)
                        || storage.getItem('session_id') !== sessionId || storage.getItem('device_hash') !== deviceHash
                        || !sameAccount(preferred, preferredAccount(storage)))
                        return [2 /*return*/, null];
                    if (storage.getItem(SESSION_KEY) !== sourceRaw)
                        return [2 /*return*/, null];
                    if (!preferred && storage.getItem(SIGNED_IN_ONCE_KEY) === 'true')
                        return [2 /*return*/, null];
                    next = {
                        version: 1,
                        apiHost: apiHost,
                        sessionToken: successor.sessionToken, expiresAt: successor.expiresAt,
                        account: { subject: successor.account.subject, tenantId: successor.account.tenantId,
                            email: (_b = successor.account.email) !== null && _b !== void 0 ? _b : null, displayName: (_c = successor.account.displayName) !== null && _c !== void 0 ? _c : null },
                    };
                    storage.setItem(SESSION_KEY, JSON.stringify(next));
                    if (preferred && storage.getItem('r2_office_preferred_account') === null)
                        storage.setItem('r2_office_preferred_account', JSON.stringify(preferred));
                    storage.setItem(SIGNED_IN_ONCE_KEY, 'true');
                    storage.removeItem('session_id');
                    storage.removeItem('device_hash');
                    storage.removeItem('r2_msal_preferred_account');
                    storage.removeItem('r2_msal_logged_out');
                    return [2 /*return*/, next.sessionToken];
            }
        });
    });
}
function isCurrentSignedOfficeToken(apiHost, sessionToken, options) {
    var _a, _b;
    if (options === void 0) { options = {}; }
    var storage = (_a = options.storage) !== null && _a !== void 0 ? _a : localStorage;
    var session = storedSession(apiHost, storage);
    return !!session && session.sessionToken === sessionToken && session.expiresAt > ((_b = options.now) !== null && _b !== void 0 ? _b : Date.now)()
        && accountIsCurrent(session, storage);
}
/** Retire credentials left by an older client after a signed API call is accepted. */
function retireLegacyOfficeStorage(apiHost, sessionToken, pairAtStart, options) {
    var _a;
    if (options === void 0) { options = {}; }
    var storage = (_a = options.storage) !== null && _a !== void 0 ? _a : localStorage;
    if (!isCurrentSignedOfficeToken(apiHost, sessionToken, { storage: storage, now: options.now })
        || storage.getItem('session_id') !== pairAtStart.sessionId
        || storage.getItem('device_hash') !== pairAtStart.deviceHash)
        return;
    var preferred = preferredAccount(storage);
    if (preferred === undefined)
        return;
    var session = storedSession(apiHost, storage);
    if (!session)
        return;
    var legacyPreferred = preferredAccountFromRaw(storage.getItem('r2_msal_preferred_account'));
    if (legacyPreferred === undefined
        || (legacyPreferred && (legacyPreferred.subject !== session.account.subject
            || legacyPreferred.tenantId !== session.account.tenantId))
        || ((pairAtStart.sessionId || pairAtStart.deviceHash) && !preferred))
        return;
    try {
        if (preferred && storage.getItem('r2_office_preferred_account') === null)
            storage.setItem('r2_office_preferred_account', JSON.stringify(preferred));
        storage.setItem(SIGNED_IN_ONCE_KEY, 'true');
        storage.removeItem('session_id');
        storage.removeItem('device_hash');
        storage.removeItem('r2_msal_preferred_account');
        storage.removeItem('r2_msal_logged_out');
    }
    catch ( /* Keep the signed request successful; a later call can retry storage cleanup. */_b) { /* Keep the signed request successful; a later call can retry storage cleanup. */ }
}
/** Uses a persisted Office signed credential, upgrading an older saved login once if needed. */
function getSignedOfficeToken(apiHost, options) {
    var _a, _b, _c, _d, _e, _f;
    if (options === void 0) { options = {}; }
    return signed_session_awaiter(this, void 0, Promise, function () {
        var storage, now, fetcher, epoch, source, token, response, current_1, successor, _g, current, next;
        return signed_session_generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    storage = (_a = options.storage) !== null && _a !== void 0 ? _a : localStorage;
                    now = (_b = options.now) !== null && _b !== void 0 ? _b : Date.now;
                    fetcher = (_c = options.fetcher) !== null && _c !== void 0 ? _c : fetch;
                    epoch = storage.getItem(EPOCH_KEY);
                    source = storedSession(apiHost, storage);
                    if (!!source) return [3 /*break*/, 2];
                    return [4 /*yield*/, exchangeLegacyOnce(apiHost, storage, now, fetcher, epoch)];
                case 1:
                    token = _h.sent();
                    return [2 /*return*/, storage.getItem(EPOCH_KEY) === epoch ? token : null];
                case 2:
                    if (!accountIsCurrent(source, storage))
                        return [2 /*return*/, null];
                    if (source.expiresAt > now() + ROTATION_MARGIN_MS)
                        return [2 /*return*/, source.sessionToken];
                    return [4 /*yield*/, fetcher("".concat(apiHost, "/api/auth/session/rotate"), {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json', Authorization: "Bearer ".concat(source.sessionToken) },
                            body: '{}',
                        })];
                case 3:
                    response = _h.sent();
                    if (response.status === 401 || response.status === 403) {
                        if (storage.getItem(EPOCH_KEY) !== epoch || !accountIsCurrent(source, storage))
                            return [2 /*return*/, null];
                        current_1 = storedSession(apiHost, storage);
                        return [2 /*return*/, current_1 && current_1.sessionToken !== source.sessionToken && current_1.expiresAt > now()
                                && current_1.account.subject === source.account.subject
                                && current_1.account.tenantId === source.account.tenantId ? current_1.sessionToken : null];
                    }
                    if (!response.ok)
                        throw new Error("Office session rotation failed: HTTP ".concat(response.status));
                    _h.label = 4;
                case 4:
                    _h.trys.push([4, 6, , 7]);
                    return [4 /*yield*/, response.json()];
                case 5:
                    successor = (_h.sent());
                    return [3 /*break*/, 7];
                case 6:
                    _g = _h.sent();
                    return [2 /*return*/, null];
                case 7:
                    if (typeof (successor === null || successor === void 0 ? void 0 : successor.sessionToken) !== 'string' || !successor.sessionToken
                        || !Number.isSafeInteger(successor.expiresAt) || successor.expiresAt <= now()
                        || ((_d = successor.account) === null || _d === void 0 ? void 0 : _d.provider) !== 'microsoft'
                        || successor.account.subject !== source.account.subject
                        || successor.account.tenantId !== source.account.tenantId
                        || (successor.account.email != null && typeof successor.account.email !== 'string')
                        || (successor.account.displayName != null && typeof successor.account.displayName !== 'string'))
                        return [2 /*return*/, null];
                    if (storage.getItem(EPOCH_KEY) !== epoch || !accountIsCurrent(source, storage))
                        return [2 /*return*/, null];
                    current = storedSession(apiHost, storage);
                    if (!current || current.account.subject !== source.account.subject
                        || current.account.tenantId !== source.account.tenantId)
                        return [2 /*return*/, null];
                    if (current.sessionToken !== source.sessionToken)
                        return [2 /*return*/, current.expiresAt > now() + ROTATION_MARGIN_MS ? current.sessionToken : null];
                    next = {
                        version: 1,
                        apiHost: apiHost,
                        sessionToken: successor.sessionToken, expiresAt: successor.expiresAt,
                        account: { subject: source.account.subject, tenantId: source.account.tenantId,
                            email: (_e = successor.account.email) !== null && _e !== void 0 ? _e : null, displayName: (_f = successor.account.displayName) !== null && _f !== void 0 ? _f : null },
                    };
                    storage.setItem(SESSION_KEY, JSON.stringify(next));
                    return [2 /*return*/, next.sessionToken];
            }
        });
    });
}

;// ./src/signed-api.ts
var signed_api_assign = (undefined && undefined.__assign) || function () {
    signed_api_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return signed_api_assign.apply(this, arguments);
};
var signed_api_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var signed_api_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};





// Every formula runs in the same custom-function runtime, so its requests must
// share one server key for a signed session. Keep test/injected fetch runtimes isolated.
var materialScopes = new WeakMap();
function materialScope(storage, fetcher, apiHost, sessionToken) {
    var byFetcher = materialScopes.get(storage);
    if (!byFetcher) {
        byFetcher = new WeakMap();
        materialScopes.set(storage, byFetcher);
    }
    var bySession = byFetcher.get(fetcher);
    if (!bySession) {
        bySession = new Map();
        byFetcher.set(fetcher, bySession);
    }
    var key = JSON.stringify([apiHost, sessionToken]);
    var scope = bySession.get(key);
    if (!scope) {
        scope = { materials: null, work: null, generation: 0 };
        bySession.set(key, scope);
    }
    return scope;
}
var SignedOfficeApi = /** @class */ (function () {
    function SignedOfficeApi(apiHost, sessionToken, secure, requestId, options) {
        if (options === void 0) { options = {}; }
        var _a, _b, _c;
        this.apiHost = apiHost;
        this.sessionToken = sessionToken;
        this.secure = secure;
        this.requestId = requestId;
        this.fetcher = (_a = options.fetcher) !== null && _a !== void 0 ? _a : fetch;
        this.now = (_b = options.now) !== null && _b !== void 0 ? _b : Date.now;
        this.storage = (_c = options.storage) !== null && _c !== void 0 ? _c : localStorage;
        this.scope = materialScope(this.storage, this.fetcher, apiHost, sessionToken);
        this.legacyPairAtStart = {
            sessionId: this.storage.getItem('session_id'), deviceHash: this.storage.getItem('device_hash'),
        };
    }
    SignedOfficeApi.prototype.getPlain = function (path) {
        return this.request('GET', path, undefined, false, true);
    };
    SignedOfficeApi.prototype.get = function (path) {
        return this.request('GET', path, undefined, this.secure, true);
    };
    SignedOfficeApi.prototype.post = function (path, body, safeRead) {
        if (safeRead === void 0) { safeRead = false; }
        return this.request('POST', path, body, this.secure, safeRead);
    };
    SignedOfficeApi.prototype.request = function (method, path, body, secure, safeRead, retried) {
        if (retried === void 0) { retried = false; }
        return signed_api_awaiter(this, void 0, Promise, function () {
            var materials, _a, payload, _b, headers, response, conflict, _c, _d, data, decrypted, error_1;
            var _e;
            return signed_api_generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        this.requireCurrent();
                        if (!secure) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getMaterials()];
                    case 1:
                        _a = _f.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = null;
                        _f.label = 3;
                    case 3:
                        materials = _a;
                        if (!(materials && method === 'POST')) return [3 /*break*/, 5];
                        _e = {};
                        return [4 /*yield*/, encryptPayload(body, materials)];
                    case 4:
                        _b = (_e.data = _f.sent(), _e);
                        return [3 /*break*/, 6];
                    case 5:
                        _b = body;
                        _f.label = 6;
                    case 6:
                        payload = _b;
                        this.requireCurrent();
                        if (materials && this.scope.materials !== materials) {
                            // No request was dispatched, so even a write can be prepared again.
                            if (!retried)
                                return [2 /*return*/, this.request(method, path, body, secure, safeRead, true)];
                            throw new Error('Session encryption materials changed');
                        }
                        headers = {
                            'Content-Type': 'application/json',
                            'x-hs-request-id': this.requestId,
                            Authorization: "Bearer ".concat(this.sessionToken),
                        };
                        if (materials) {
                            headers[TRANSPORT_CONTRACT_HEADER] = TRANSPORT_CONTRACT_VERSION;
                            headers[TRANSPORT_CONTEXT_HEADER] = materials.transportVersion;
                        }
                        return [4 /*yield*/, this.fetcher("".concat(this.apiHost).concat(officeApiRoute(method, path, secure)), signed_api_assign({ method: method, headers: headers }, (method === 'POST' ? { body: JSON.stringify(payload) } : {})))];
                    case 7:
                        response = _f.sent();
                        if (!(response.status === 409 && secure)) return [3 /*break*/, 12];
                        conflict = null;
                        _f.label = 8;
                    case 8:
                        _f.trys.push([8, 10, , 11]);
                        return [4 /*yield*/, response.clone().json()];
                    case 9:
                        conflict = (_f.sent());
                        return [3 /*break*/, 11];
                    case 10:
                        _c = _f.sent();
                        return [3 /*break*/, 11];
                    case 11:
                        if ((conflict === null || conflict === void 0 ? void 0 : conflict.code) === 'SESSION_TRANSPORT_CONTEXT_CHANGED') {
                            this.invalidateMaterials(materials);
                            if (safeRead && !retried)
                                return [2 /*return*/, this.request(method, path, body, secure, safeRead, true)];
                        }
                        _f.label = 12;
                    case 12:
                        if (response.status === 401) {
                            this.invalidateMaterials(materials);
                            throw new Error(ERROR_MESSAGE[ERROR_NAME.SESSION_NOT_FOUND]);
                        }
                        if (!!response.ok) return [3 /*break*/, 14];
                        _d = Error.bind;
                        return [4 /*yield*/, this.errorMessage(response)];
                    case 13: throw new (_d.apply(Error, [void 0, _f.sent()]))();
                    case 14: return [4 /*yield*/, response.json()];
                    case 15:
                        data = _f.sent();
                        this.requireCurrent();
                        if (!materials) {
                            this.retireLegacyStorage();
                            return [2 /*return*/, data];
                        }
                        _f.label = 16;
                    case 16:
                        _f.trys.push([16, 18, , 19]);
                        return [4 /*yield*/, decryptPayload(encryptedEnvelopeData(data), materials)];
                    case 17:
                        decrypted = _f.sent();
                        this.requireCurrent();
                        this.retireLegacyStorage();
                        return [2 /*return*/, decrypted];
                    case 18:
                        error_1 = _f.sent();
                        if (error_1 instanceof Error && (error_1.message === DECRYPT_ERROR_MESSAGE
                            || error_1.message === MISSING_ENCRYPTED_DATA_MESSAGE)) {
                            this.invalidateMaterials(materials);
                            if (safeRead && !retried)
                                return [2 /*return*/, this.request(method, path, body, secure, safeRead, true)];
                        }
                        throw error_1;
                    case 19: return [2 /*return*/];
                }
            });
        });
    };
    SignedOfficeApi.prototype.getMaterials = function () {
        return signed_api_awaiter(this, void 0, Promise, function () {
            var generation_1, work_1, materials;
            var _this = this;
            return signed_api_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.scope.materials)
                            return [2 /*return*/, this.scope.materials];
                        if (!this.scope.work) {
                            generation_1 = this.scope.generation;
                            work_1 = this.exchangeKey().then(function (materials) {
                                _this.requireCurrent();
                                if (_this.scope.generation !== generation_1)
                                    throw new Error('Session encryption materials changed');
                                _this.scope.materials = materials;
                                return materials;
                            });
                            this.scope.work = work_1;
                            void work_1.then(function () { if (_this.scope.work === work_1)
                                _this.scope.work = null; }, function () { if (_this.scope.work === work_1)
                                _this.scope.work = null; });
                        }
                        return [4 /*yield*/, this.scope.work];
                    case 1:
                        materials = _a.sent();
                        this.requireCurrent();
                        return [2 /*return*/, materials];
                }
            });
        });
    };
    SignedOfficeApi.prototype.invalidateMaterials = function (materials) {
        // A late failure must not clear materials already replaced by another request.
        if (materials && this.scope.materials !== materials)
            return;
        this.scope.materials = null;
        this.scope.work = null;
        this.scope.generation++;
    };
    SignedOfficeApi.prototype.exchangeKey = function () {
        var _a;
        return signed_api_awaiter(this, void 0, Promise, function () {
            var pair, publicKey, response, _b, payload, materials;
            var _c;
            return signed_api_generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, generateEcdhKeyPair()];
                    case 1:
                        pair = _d.sent();
                        return [4 /*yield*/, exportPublicKey(pair.publicKey)];
                    case 2:
                        publicKey = _d.sent();
                        this.requireCurrent();
                        return [4 /*yield*/, this.fetcher("".concat(this.apiHost, "/api/secure/session/key/set"), {
                                method: 'POST',
                                headers: (_c = {
                                        'Content-Type': 'application/json',
                                        'x-hs-request-id': this.requestId,
                                        Authorization: "Bearer ".concat(this.sessionToken)
                                    },
                                    _c[TRANSPORT_CONTRACT_HEADER] = TRANSPORT_CONTRACT_VERSION,
                                    _c),
                                body: JSON.stringify({ public_key: publicKey }),
                            })];
                    case 3:
                        response = _d.sent();
                        if (response.status === 401)
                            throw new Error(ERROR_MESSAGE[ERROR_NAME.SESSION_NOT_FOUND]);
                        if (!!response.ok) return [3 /*break*/, 5];
                        _b = Error.bind;
                        return [4 /*yield*/, this.errorMessage(response)];
                    case 4: throw new (_b.apply(Error, [void 0, _d.sent()]))();
                    case 5: return [4 /*yield*/, response.json()];
                    case 6:
                        payload = _d.sent();
                        if (!(payload === null || payload === void 0 ? void 0 : payload.public_key) || !((_a = payload.transport_context_version) === null || _a === void 0 ? void 0 : _a.trim()))
                            throw new Error('Secure key exchange returned invalid metadata');
                        return [4 /*yield*/, deriveSessionMaterials(pair.privateKey, payload.public_key)];
                    case 7:
                        materials = _d.sent();
                        this.requireCurrent();
                        return [2 /*return*/, signed_api_assign(signed_api_assign({}, materials), { transportVersion: payload.transport_context_version })];
                }
            });
        });
    };
    SignedOfficeApi.prototype.requireCurrent = function () {
        if (!isCurrentSignedOfficeToken(this.apiHost, this.sessionToken, { storage: this.storage, now: this.now }))
            throw new Error(ERROR_MESSAGE[ERROR_NAME.SESSION_NOT_FOUND]);
    };
    SignedOfficeApi.prototype.retireLegacyStorage = function () {
        retireLegacyOfficeStorage(this.apiHost, this.sessionToken, this.legacyPairAtStart, { storage: this.storage, now: this.now });
    };
    SignedOfficeApi.prototype.errorMessage = function (response) {
        return signed_api_awaiter(this, void 0, Promise, function () {
            var body, _a;
            return signed_api_generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, response.json()];
                    case 1:
                        body = _b.sent();
                        if (typeof (body === null || body === void 0 ? void 0 : body.message) === 'string' && body.message)
                            return [2 /*return*/, body.message];
                        return [3 /*break*/, 3];
                    case 2:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, ERROR_MESSAGE[ERROR_NAME.UNKNOWN_ERROR]];
                }
            });
        });
    };
    return SignedOfficeApi;
}());


;// ./src/functions.ts
var functions_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var functions_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var functions_a;





var API_HOST = (functions_a = "MISSING_ENV_VAR".API_HOST) !== null && functions_a !== void 0 ? functions_a : '';
var SECURE_TRANSPORT_ENABLED = "MISSING_ENV_VAR".SECURE_TRANSPORT_ENABLED === 'true';
// The backend may persist the assistant answer slightly after msg/send
// resolves, so we poll msgs/get until the new message shows up.
var ANSWER_POLL_INTERVAL_MS = 1200;
var ANSWER_POLL_TIMEOUT_MS = 90 * 1000;
// The add-in persists the user's active copilot selection here (IndexedDB,
// same origin so the custom-function runtime can read it). Mirrors
// environment.db + SCHEMA_NAME_CHAT_SETTING in the add-in.
var DB_NAME_CHAT = 'r2-copilot';
var STORE_NAME_CHAT_SETTING = 'chatSetting';
function tableAsText(content) {
    var contentStr = '';
    if (Array.isArray(content) && content.length === 1) {
        var firstVal = content[0];
        if (Array.isArray(firstVal) && firstVal.length === 1) {
            var singleVal = firstVal[0];
            if (Array.isArray(singleVal) || typeof singleVal === 'object' || typeof singleVal === 'undefined') {
                contentStr = JSON.stringify(singleVal);
            }
            else if (typeof singleVal === 'string') {
                contentStr = singleVal;
            }
            else {
                contentStr = "".concat(singleVal);
            }
        }
        else {
            contentStr = JSON.stringify(firstVal);
        }
    }
    else {
        contentStr = JSON.stringify(content);
    }
    if (typeof content === 'string') {
        return content;
    }
    return contentStr;
}
function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}
/**
 * This function apply action from first argument to the content from second argument.
 * @customfunction CopilotR2
 * @helpurl https://r2copilot.ai/help/excel
 * @param prompt {string} (Required). The text of prompt to sent to R2 Copilot.
 * @param content {string[][]} (Optional). Some content to attach in request to R2 Copilot.
 * @param completion_length {number} (Optional). Gives model instructions recommendations on response length. Can be from 10 to 8000. By default equals 2000.
 * @param completion_tone {string} (Optional). Gives the model instructions about how it should behave and the context it should reference when generating a response.
 * Can be a string or a reference to a cell containing the appropriate text.
 * By default equal a predefined 'formal' instructions.
 * @returns {Promise<string>} Response message from R2 Copilot.
 */
function sendActionAsync(prompt, content, completion_length, completion_tone) {
    return functions_awaiter(this, void 0, Promise, function () {
        var responseText, request, contentStr, err_1;
        return functions_generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    if (!prompt || String(prompt).length == 0) {
                        throw new Error("Missing required argument prompt");
                    }
                    request = "".concat(prompt);
                    if (content) {
                        contentStr = tableAsText(content);
                        console.log(contentStr);
                        if (contentStr) {
                            request += "".concat(contentStr);
                        }
                    }
                    return [4 /*yield*/, requestAsync(request, completion_length, completion_tone)];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    err_1 = _a.sent();
                    responseText = "#ERROR: ".concat((err_1.message || JSON.stringify(err_1)));
                    console.error(responseText);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/, responseText];
            }
        });
    });
}
function requestAsync(prompt, completion_length, completion_tone) {
    var _a, _b, _c, _d, _e, _f;
    return functions_awaiter(this, void 0, Promise, function () {
        var sessionToken, api, defaults, userSettings, copilotsRes, copilots, persistedCopilotId, activeCopilot, copilotId, sendRequest, sendRes;
        return functions_generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    if (!prompt || String(prompt).length === 0) {
                        throw new Error("Missing required arguments prompt");
                    }
                    if (prompt === '[object Object]') {
                        throw new Error("Put your value in quotes");
                    }
                    if (completion_length && (completion_length < 10 || completion_length > 8000)) {
                        throw new Error("Invalid argument value length. Must be between 10 and 8000.");
                    }
                    return [4 /*yield*/, getSignedOfficeToken(API_HOST)];
                case 1:
                    sessionToken = _g.sent();
                    if (!sessionToken) {
                        throw new CustomFunctions.Error(CustomFunctions.ErrorCode.notAvailable, "Session didn't found,please login with R2 Copilot Add-in");
                    }
                    api = new SignedOfficeApi(API_HOST, sessionToken, SECURE_TRANSPORT_ENABLED, uuidv4());
                    return [4 /*yield*/, api.getPlain('/chat-defaults')];
                case 2:
                    defaults = _g.sent();
                    return [4 /*yield*/, getOptionalSettings(api)];
                case 3:
                    userSettings = _g.sent();
                    return [4 /*yield*/, api.get('/copilots')];
                case 4:
                    copilotsRes = _g.sent();
                    copilots = (_a = copilotsRes.copilots) !== null && _a !== void 0 ? _a : [];
                    return [4 /*yield*/, readPersistedCopilotId()];
                case 5:
                    persistedCopilotId = _g.sent();
                    activeCopilot = (_b = (persistedCopilotId ? copilots.find(function (c) { return c.id === persistedCopilotId; }) : null)) !== null && _b !== void 0 ? _b : copilots[0];
                    copilotId = (_c = activeCopilot === null || activeCopilot === void 0 ? void 0 : activeCopilot.id) !== null && _c !== void 0 ? _c : '';
                    sendRequest = {
                        copilot_id: copilotId,
                        text: prompt,
                        model: ((_d = userSettings === null || userSettings === void 0 ? void 0 : userSettings.selectedChatModel) === null || _d === void 0 ? void 0 : _d.apiName) || defaults.model,
                        instruction: completion_tone || ((_e = userSettings === null || userSettings === void 0 ? void 0 : userSettings.answerLength) === null || _e === void 0 ? void 0 : _e.instruction) || defaults.instruction,
                        max_bytes_output: completion_length || ((_f = userSettings === null || userSettings === void 0 ? void 0 : userSettings.answerLength) === null || _f === void 0 ? void 0 : _f.outputTokenLimit) || defaults.max_bytes_output,
                    };
                    return [4 /*yield*/, api.post('/msg/send', sendRequest)];
                case 6:
                    sendRes = _g.sent();
                    if (sendRes.result !== R2SendMessageResult.Success || !sendRes.thread_id) {
                        throw new Error(mapSendError(sendRes.result));
                    }
                    return [4 /*yield*/, pollForAnswer(sendRes.thread_id, api)];
                case 7: return [2 /*return*/, _g.sent()];
            }
        });
    });
}
function getOptionalSettings(api) {
    return functions_awaiter(this, void 0, Promise, function () {
        var _a;
        return functions_generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, api.getPlain('/user/settings')];
                case 1: return [2 /*return*/, _b.sent()];
                case 2:
                    _a = _b.sent();
                    return [2 /*return*/, null];
                case 3: return [2 /*return*/];
            }
        });
    });
}
// Reads the active copilot id the add-in persisted in IndexedDB. Best-effort:
// any failure (db absent, store missing, runtime without IndexedDB) yields null
// so the caller falls back to the first copilot. The setting key is
// `${user_id}-${host}`; user_id isn't known here, so match the current host
// suffix, then any record carrying a copilotId.
function readPersistedCopilotId() {
    var _a, _b, _c, _d;
    return functions_awaiter(this, void 0, Promise, function () {
        var host_1, settings, match, _e;
        return functions_generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 2, , 3]);
                    host_1 = ((_b = (_a = office === null || office === void 0 ? void 0 : office.context) === null || _a === void 0 ? void 0 : _a.host) !== null && _b !== void 0 ? _b : '').toString();
                    return [4 /*yield*/, readChatSettings()];
                case 1:
                    settings = _f.sent();
                    match = (_c = settings.find(function (s) { return !!s.copilotId && typeof s.user === 'string' && s.user.endsWith("-".concat(host_1)); })) !== null && _c !== void 0 ? _c : settings.find(function (s) { return !!s.copilotId; });
                    return [2 /*return*/, (_d = match === null || match === void 0 ? void 0 : match.copilotId) !== null && _d !== void 0 ? _d : null];
                case 2:
                    _e = _f.sent();
                    return [2 /*return*/, null];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function readChatSettings() {
    return new Promise(function (resolve, reject) {
        // Open without a version so we never trigger an upgrade/downgrade
        // against the db the add-in owns.
        var open = indexedDB.open(DB_NAME_CHAT);
        open.onerror = function () { return reject(open.error); };
        open.onsuccess = function () {
            var db = open.result;
            if (!db.objectStoreNames.contains(STORE_NAME_CHAT_SETTING)) {
                db.close();
                resolve([]);
                return;
            }
            var request = db.transaction(STORE_NAME_CHAT_SETTING, 'readonly')
                .objectStore(STORE_NAME_CHAT_SETTING)
                .getAll();
            request.onsuccess = function () {
                var _a;
                resolve((_a = request.result) !== null && _a !== void 0 ? _a : []);
                db.close();
            };
            request.onerror = function () {
                reject(request.error);
                db.close();
            };
        };
    });
}
// After msg/send, wait for the new answer to appear via msgs/get (same
// fetch-after-send flow as OfficeChatV1.fetchLatestAnswer).
function pollForAnswer(threadId, api) {
    var _a;
    return functions_awaiter(this, void 0, Promise, function () {
        var deadline, body, res, assistant;
        return functions_generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    deadline = Date.now() + ANSWER_POLL_TIMEOUT_MS;
                    _b.label = 1;
                case 1:
                    body = {
                        thread_id: threadId,
                        page_size: 1,
                        msg_order: 'desc',
                    };
                    return [4 /*yield*/, api.post('/msgs/get', body, true)];
                case 2:
                    res = _b.sent();
                    assistant = ((_a = res.chat_history) !== null && _a !== void 0 ? _a : []).find(function (m) { var _a; return m.role === 'ASSISTANT' && !!((_a = m.content) === null || _a === void 0 ? void 0 : _a.text); });
                    if (assistant) {
                        return [2 /*return*/, assistant.content.text];
                    }
                    return [4 /*yield*/, delay(ANSWER_POLL_INTERVAL_MS)];
                case 3:
                    _b.sent();
                    _b.label = 4;
                case 4:
                    if (Date.now() < deadline) return [3 /*break*/, 1];
                    _b.label = 5;
                case 5: throw new Error(ERROR_MESSAGE[ERROR_NAME.REQUEST_TIMEOUT]);
            }
        });
    });
}
function delay(ms) {
    return new Promise(function (resolve) { return setTimeout(resolve, ms); });
}
function mapSendError(result) {
    switch (result) {
        case R2SendMessageResult.FailTokenInvalid:
        case R2SendMessageResult.FailTokenExpired:
        case R2SendMessageResult.FailAccessDenied:
            return ERROR_MESSAGE[ERROR_NAME.SESSION_NOT_FOUND];
        case R2SendMessageResult.FailServiceTemporaryNotValid:
            return ERROR_MESSAGE[ERROR_NAME.HIGH_TRAFFIC];
        case R2SendMessageResult.FailServiceMaintenance:
            return ERROR_MESSAGE[ERROR_NAME.SERVICE_MAINTENANCE];
        case R2SendMessageResult.FailInsufficientBalance:
            return ERROR_MESSAGE[ERROR_NAME.INSUFFICIENT_TOKENS];
        default:
            return ERROR_MESSAGE[ERROR_NAME.UNKNOWN_ERROR];
    }
}
function setForceRefreshOn() {
    office.context.document.settings.set('Office.ForceRefreshCustomFunctionsCache', true);
    office.context.document.settings.saveAsync();
}
window.setForceRefreshOn = setForceRefreshOn;
CustomFunctions.associate("COPILOTR2", sendActionAsync);

;// ./src/index.ts


/******/ })()
;